








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
//import { VueYoutube } from "vue-youtube";
//Vue.use(VueYoutube);

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}
interface Description2 {
  id: string;
  title: string;
  descriptions: Array<Td2>;
}
interface Description2d {
  id: string;
  title: string;
  descriptions: Array<Td2d>;
}
interface Td2 {
  id: string;
  title: string;
  rows: Array<Row>;
  comments: Array<Comment>;
  videos: Array<Video>;
}
interface Td2d {
  id: string;
  title: string;
  rows: Array<Row>;
  comments: Array<Comment>;
  videos: Array<Video>;
  images: Array<Image>
}
interface Row {
  items: Array<string>;
}
interface Comment {
  title: string;
  items: Array<string>;
}
interface Comment3 {
  title: string;
  items: Array<Td3>;
}
interface Td3 {
  id: string;
  td1: Array<string>;
  td2: string;
  td3: string;
  turn: Array<string>;
  s_turn: Array<string>;
}
interface Video {
  title: string;
  videoId: string;
}
interface Video1 {
  id: string;
  title: string;
  videoId: string;
}
interface Figure {
  title: string;
  image: string;
}

@Component
export default class DanceComponent extends Vue {
  @Prop()
  private msg!: string;
  private signinStatus = "signed out"

  private isActive = "1"
  private videoId: string = "5OWIEXYoW2w"
  
  private activeClass = "arrow"
  private errorClass = "fwd"
  private arrayClass = ["arrow", "fwd"]
  
  created() {
    const user = this.$auth.currentUser
    if (user) {
      // User is signed in.
      const email = user.email
      const uid = user.uid
      this.signinStatus = "signed in"
      //window.console.log("created() 2.User is signed in: ")
      //window.console.log("created() 3.uid: " + uid)
      //window.console.log("created() 4.email: " + email)
    } else {
      // No user is signed in.
      this.signinStatus = "signed out"
      window.console.log("created() 5.No user is signed in: ")
      // 単純な遷移
      //this.$router.push('/signin/')
    }
  }

  private ready() {
    window.console.log("ready() 1.")
    /*
    const youtubePlayer = this.$refs.youtube.player
    youtubePlayer.resize = true
    window.console.log("ready() 2.width: " + youtubePlayer.width)
    youtubePlayer.fitParent = true
    youtubePlayer.width = 1280
    youtubePlayer.height= 720
    window.console.log("ready() 3.width: " + youtubePlayer.width)
    youtubePlayer.resize = true
    youtubePlayer.playVideo()
    */
  } 
  
  play() {
  console.log("play() 1.");
  //var input = context.createMediaStreamSource(stream)
  //console.log("play() 2.");
  //var processor = context.createScriptProcessor(1024, 1, 1);
  //console.log("play() 3.");
  ///*
  //const video = document.createElement("video");
  const constraints = {"audio": false, "video": true }
  navigator.mediaDevices.getUserMedia(constraints)
  .then(stream => {
    // カメラ(stream)が使えるよ
    console.log("play() 2.カメラ使えるよ");
    const video = document.querySelector<HTMLVideoElement>('video');
    //const video: HTMLVideoElement = document.createElement("video");
    video!.srcObject = stream
    video!.onloadedmetadata = function(e) {
      console.log("play() 3.動画を演奏する");
      // 動画を演奏する
      video!.play();
    };

  })
  //.then((resolve) => {
  //  video.onloadmetadata = resolve
  //})
  .catch(error => {
    console.log(error)
  })
  //*/
  /*
  navigator.mediaDevices = navigator.mediaDevices || ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? {
     getUserMedia: function(c) {
       return new Promise(function(y, n) {
         (navigator.mozGetUserMedia ||
          navigator.webkitGetUserMedia).call(navigator, c, y, n);
       });
     }
  } : null);

  console.log("play() 2.");
  if (!navigator.mediaDevices) {
    console.log("play() 3. getUserMedia() not supported.");
    return;
  }

  // Prefer camera resolution nearest to 1280x720.

  //var constraints = { audio: true, video: { width: 1280, height: 720 } };
  var constraints = { audio: false, video: true };

  // getUserMedia()関数を実行する
  navigator.mediaDevices.getUserMedia(constraints)
  .then(function(stream) {
    // カメラ(stream)が使えるよ
    console.log("play() 4.カメラ使えるよ");
    var video = document.querySelector('video');
    // video selectorにセットする
    video.srcObject = stream
    video.onloadedmetadata = function(e) {
      // 動画を演奏する
      video.play();
    };
  })
  .catch(function(err) {
    // カメラ使えない
    console.log("play() 5.カメラ使えない");
    console.log(err.name + ": " + err.message);
  });
  */
  }

  private contents1: Description = {
    id: "1",
    title: "「トークA愛」のご紹介",
    descriptions: [
      {
        id: "1",
        title: "「トークA愛」の特徴",
        images: [
          {
            src: "",
            comment: "",
          },
        ],
        items: [
          "「トークA愛」は、ネット上の仮想的なダンスの練習の場です。カラオケの練習もできます。",
          "「トークA愛」では、あくまでダンスの練習の予習と復習を行うだけなので、正しい踊りはダンス教室の先生について指導を受けて下さい。",
          "「トークA愛」では、文字情報・音楽・動画・youtube動画を利用してダンスやカラオケの練習を行います。",
          "「トークA愛」では、初級者向けに「ワルツ」「タンゴ」「ルンバ」「チャチャチャ」「ジルバ」「マンボ」等を練習します。",
          "「トークA愛」では、中級者向けに「スロー」「クイック」を中心に「ワルツ」「タンゴ」「ルンバ」「チャチャチャ」「ジルバ」「マンボ」等を練習します。"
        ],
        pres: [],
     }, // end of id=1
     {
       id: "2",
       title: "「トークA愛」の文字情報によるダンス（カラオケ）の練習",
       images: [
         {
           src: "",
           comment: ""
         },
       ],
       items: [
         "ダンスは「記憶力」が非常に重要なスポーツです。記憶が苦手な人は、ダンスも苦手と言っても過言ではありません。",
         "「記憶力」が、空間における自分の踊りの「あるべき」位置と動きを決めます。加えて相手との位置関係も考慮する必要があります。",
         "「トークA愛」の「トークA愛タブ」を選択すると「スロー」「ワルツ」「タンゴ」「ルンバ」などのダンスのステップ（Amalgamation）の解説があります。",
         "「トークA愛」が提供するダンスのステップ（Amalgamation）の解説を使用して、自分の踊りの「あるべき」位置と動きを記憶する事ができます。",
         "「トークA愛」は、それぞれのダンスのステップに対して、参考になるYoutube動画も見る事ができます。"
       ],
       pres: [],
     }, // end of id=2
     {
       id: "3",
       title: "「トークA愛」の音楽によるダンス（カラオケ）の練習",
       images: [
         {
           src: "",
           comment: "",
         },
       ],
       items: [
         "「トークA愛」の「音楽タブ」を選択するとダンス（カラオケ）音楽を選択できます。",
         "「トークA愛」が提供するダンス（カラオケ）音楽を使用して、自宅などでダンス（カラオケ）の予習と復習を行う事ができます。",
         "「トークA愛」を使用して、自宅などでダンス（カラオケ）の練習を行っている動画を撮影して、自分の踊りを客観的に分析する事ができます。"
       ],
       pres: [],
     }, // end of id=3
     {
       id: "4",
       title: "「トークA愛」の動画によるダンス（カラオケ）の練習",
       images: [
         {
           src: "",
           comment: "",
         },
       ],
       items: [
         "スマホやタブレットなどでダンス教室の練習風景を撮影し、「トークA愛」でそのダンス動画を見る事ができます。",
         "「トークA愛」の「動画タブ」を選択するとダンス動画を選択して視聴する事ができます。",
         "「トークA愛」が提供するダンス動画を使用して、ダンスの予習と復習を行う事ができます。"
       ],
       pres: [],
     }, // end of id=4
     {
       id: "5",
        title: "「トークA愛」のYoutube動画によるダンス（カラオケ）の練習",
        images: [
          {
            src: "",
           comment: "",
          },
        ],
        items: [
          "Youtubeには参考になる様々なダンスやカラオケの動画が投稿されています。",
          "「トークA愛」の「Youtube動画タブ」を選択すると、そのYoutube動画を選択して視聴する事ができます。",
          "「トークA愛」が提供するダンス（カラオケ）Youtube動画を使用して、ダンス（カラオケ）の予習と復習を行う事ができます。"
        ],
        pres: [],
     }, // end of id=5
     {
       id: "6",
       title: "「トークA愛」のYoutubeライブ動画によるダンス（カラオケ）の練習： 開発中",
       images: [
         {
           src: "",
           comment: "",
         },
       ],
       items: [
         "コロナ禍の現代では、ダンス教室ではなく自宅でZoom会議のようにネット経由で先生の指導を受けたい場合があります。",
         "Googleの「Youtubeライブ動画」機能を使うと、ダンス教室にPCとWebカメラをネット環境があれば、先生の動画をライブ放送する事ができます。",
         "「トークA愛」の「Youtubeライブ動画タブ」を選択するとダンス（カラオケ）Youtubeライブ動画を選択できます。",
         "「トークA愛」が提供するダンス（カラオケ）Youtubeライブ動画を使用して、ダンス（カラオケ）の先生の指導を受ける事ができます。"
       ],
       pres: [],
     }, // end of id=6
     {
       id: "7",
       title: "「トークA愛」の課題と対策： 検討中",
       images: [
         {
           src: "",
           comment: "",
         },
       ],
       items: [
         "Youtubeライブ動画によるダンス（カラオケ）の練習機能： 開発中",
         "視聴者の認証機能: Googleのfirebase/firestore機能を使って開発中",
         "ダンス教室（先生）のビジネス化: 視聴者の認証機能を利用して課金できるようにする（検討中）。",
         "容量の大きい音楽・動画コンテンツをどこに格納するか→httpsサーバに置く必要がある: Youtubeに格納するのが最も安価?（検討中）。",
         "WebブラウザでWebカメラ（マイク機能内蔵）を使いたい→WebRTC機能を使う必要がある: httpsサーバが必要（検討中）。",
         "Webカメラ（又はタブレット）で撮影した画像（motion jpeg）を見守り用に使いたい→WebSpcketサーバ機能を使う必要がある: httpsサーバが必要（検討中）。",
       ],
       pres: [],
     }, // end of id=7

    ]
  } // end of contents1

  foxtrot_videos: Video1[] = [
  	{id: "1", title: "社交ダンス スローフォックストロット①・② 初級ステップ（SlowFoxtrot for Beginer）", videoId: "h4LfkNTCJjM"},
  	{id: "2", title: "社交ダンス スローフォックストロット旧③初心者用ステップ（Slowfoxtrot for beginners）", videoId: "PdWStf_va1c"},
  	{id: "3", title: "社交ダンス スローフォックストロット③ 初中級ステップ（SlowFoxtrot for Pre-Intermediate）", videoId: "c93eoPQ5YAY"},
  	{id: "4", title: "社交ダンス スローフォックストロット④ 初中級ステップ （Slow Foxtrot for Pre-Intermediate）", videoId: "-Qz0P48exEQ"},
  	{id: "5", title: "社交ダンス スローフォックストロット⑤ 中級ステップ （Slow Foxtrot for Intermediate）", videoId: "jq0W-FWAFIw"},
  	{id: "6", title: "社交ダンス スローフォックストロット⑥ 中級ステップ （Slow Foxtrot for Intermediate）", videoId: "8AUrAokWU5A"},
  ]

  foxtrot_amalgamations: Comment3[] = [
    {
      title: "中級コース: part #1",
      items: [
        { id: "0", td1: ["予備歩", "Preposition Step(S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["フェザー・ステップ*", "Feather Step(SQQ)"], td2: "0", td3: "男性は、女性のout sideに右足を出す。", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["リバース・ターン＆フェザー・フィニッシュ*", "Reverse Turn & Feather Finish(SQQ SQQ)"], td2: "fwd L3/8→back L3/8 = R1/4", td3: "男性は、女性のout sideに右足を出す。", turn: ["arrow", "R1-4"], s_turn: ["arrow", "R1-4"]  },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "R1-4"]  },
        { id: "4", td1: ["ナチュラル・ターン*", "Natural Turn(SQQ)"], td2: "R3/8", td3: "", turn: ["arrow", "R3-8"], s_turn: ["arrow", "L3-8"]  },
        { id: "5", td1: ["クローズド・インピタス＆フェザー・エンディング*", "Closed Impetus & Feather Finish(SQQ SQQ)"], td2: "Heel Turn R5/8→back L1/4 = R3/8", td3: "男性は、女性のout sideに右足を出す。", turn: ["arrow", "R3-8"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["ナチュラル・ターン*", "Natural Turn(SQQ)"], td2: "R3/8", td3: "", turn: ["arrow", "R3-8"], s_turn: ["arrow", "R3-8"]  },
        { id: "6", td1: ["チェンジ・オブ・ダイレクション*", "Change of Direction(SSS)"], td2: "R1/8", td3: "", turn: ["arrow", "R1-8"], s_turn: ["arrow", "bwd"]  },
        { id: "0", td1: ["", ""], td2: "R1/4 + R3/8 + R3/8 + R3/8 + R1/8 = R1/2", td3: "", turn: ["arrow", "bwd"], s_turn: ["arrow", "bwd"]  },
        { id: "0", td1: ["予備歩", "Preposition Step(S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "1", td1: ["フェザー・ステップ*", "Feather Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "2", td1: ["リバース・ターン＆フェザー・フィニッシュ*", "Reverse Turn & Feather Finish(SQQ SQQ)"], td2: "fwd L3/8→back L3/8 = R1/4", td3: "", turn: ["arrow", "R1-4"], s_turn: ["arrow", "L1-4"]  },
        { id: "11", td1: ["リバース・ウィーヴ(1-4)", "Reverse Weave(SQQS)"], td2: "L5/8 = R3/8", td3: "", turn: ["arrow", "L3-8"], s_turn: ["arrow", "R1-8"]  },
        { id: "7", td1: ["ベーシック・ウィーヴ*", "Basic Weave(QQ QQQQ)"], td2: "L1/4 + L1/4 = L1/2", td3: "", turn: ["arrow", "R1-8"], s_turn: ["arrow", "L3-8"]  },
        { id: "12", td1: ["リバース・ウェーヴ*", "Reverse Wave(SQQ SQQ)"], td2: "L3/4 = R1/4", td3: "", turn: ["arrow", "R3-8"], s_turn: ["arrow", "L1-8"]  },
        { id: "6", td1: ["チェンジ・オブ・ダイレクション*", "Change of Direction(SSS)"], td2: "R1/8", td3: "", turn: ["arrow", "bwd"], s_turn: ["arrow", "fwd"]  },
        { id: "0", td1: ["最初の位置になる", ""], td2: "R1/4 + R3/8 + L1/2 + R1/4 + R1/8 = L1/2", td3: "", turn: ["arrow", "bwd"], s_turn: ["arrow", "fwd"]  }
      ],
    }, //end of #1 part
    {
      title: "中級コース: part #2",
      items: [
        { id: "0", td1: ["予備歩", "Preposition Step(S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["フェザー・ステップ*", "Feather Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["オープン・テレマーク＆フェザー・エンディング*", "Open Telemark & Feather Ending(SQQ SQQ)"], td2: "L1/4 + L1/2 = L3/4 = R1/4", td3: "3QでPPの形になる。", turn: ["arrow", "R1-4"], s_turn: ["arrow", "R1-4"] },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "R1-4"]  },
        { id: "14", td1: ["ホバー・クロス*", "Hover Cross(SQQ QQQQ)"], td2: "R1/4 + R1/2 + L1/4 = R1/2", td3: "前進・後退を繰り返す。", turn: ["arrow", "bwd"], s_turn: ["arrow", "L1-4"] },
        { id: "15", td1: ["フォーラウェイ・リバース＆スリップ・ピボット*", "Fallaway Reverse & Slip Pivot(QQQQ)"], td2: "L 3/8 + L1/8 + L1/8 + L1/4 = L7/8 = R1/8", td3: "4歩で左に7/8回転する。", turn: ["arrow", "L3-8"], s_turn: ["arrow", "L1-8"] },
        { id: "8", td1: ["バウンス・ファラウェイ・ウィーブ・エンディング*", "Bounce Fallaway with Weave Ending(S&QQ QQQQ)"], td2: "L3/8 + L1/8 + L1/4 = L3/4 = R1/4", td3: "", turn: ["arrow", "L1-8"], s_turn: ["arrow", "R1-8"]  },
        { id: "6", td1: ["チェンジ・オブ・ダイレクション*", "Change of Direction(SSS)"], td2: "L5/8", td3: "左回転", turn: ["arrow", "R1-4"], s_turn: ["arrow", "bwd"] },
        { id: "0", td1: ["", ""], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "0", td1: ["予備歩", "Preposition Step(S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "9", td1: ["ナチュラル・ウィーヴ*", "Natural Weave(SQQ QQQQ)"], td2: "R1/4 + L1/4 = 0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "1", td1: ["リバース・ターン＆フェザー・フィニッシュ*", "Reverse Turn & Feather Finish(SQQ SQQ)"], td2: "L3/8 + L3/8 = L3/4 = R1/4", td3: "", turn: ["arrow", "R1-4"], s_turn: ["arrow", "L1-4"]  },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "R1-4"], s_turn: ["arrow", "L1-4"]  },
        { id: "17", td1: ["ナチュラル・ツイスト・ターン＆ホバー*", "Natural Twist Turn & Hover(SQ&Q SQQ)"], td2: "R1/4 + R1/8 + R3/8 = R3/4 = L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "bwd"]  },
        { id: "12", td1: ["リバース・ウェーヴ*", "Reverse Wave(SQQ SQQ)"], td2: "L3/8 + L1/8 + L1/8 = L5/8 = R3/8", td3: "左に弧を描きながら後退する。", turn: ["arrow", "R3-8"], s_turn: ["arrow", "L1-8"] },
        { id: "6", td1: ["チェンジ・オブ・ダイレクション*", "Change of Direction(SSS)"], td2: "R 1/8", td3: "右回転", turn: ["arrow", "R1-8"], s_turn: ["arrow", "fwd"] },
        { id: "0", td1: ["最初の位置になる", ""], td2: "R1/4 + L1/4 + R3/8 + R1/8 = L1/2", td3: "", turn: ["arrow", "bwd"], s_turn: ["arrow", "fwd"]  },
     ],
    }, //end of #2 part
    {
      title: "中級コース: part #3",
      items: [
        { id: "0", td1: ["予備歩(0)", "Preposition Step(S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["フェザー・ステップ*", "Feather Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["バウンス・ファラウェイ・ウィーブ・エンディング", "Bounce Fallaway with Weave Ending(S&QQ QQQQ)"], td2: "L3/8 + L1/8 + L1/4 = L3/4 = R1/4", td3: "", turn: ["arrow", "R1-4"], s_turn: ["arrow", "R1-4"]  },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "R1-4"]  },
        { id: "18", td1: ["ナチュラル・ホバー・テレマーク*", "Natural Hover Telemark(SQQ SQQ)"], td2: "R1/4 + R1/2 = R3/4 = L1/4", td3: "前半の3stepは「Hover Cross」と同じである。", turn: ["arrow", "L1-4"], s_turn: ["arrow", "fwd"] },
        { id: "12", td1: ["リバース・ウェーヴ*", "Reverse Wave(SQQ SQQ SS)"], td2: "L3/8 + L1/8 + L1/8 + R3/8 = L1/4", td3: "左に弧を描きながら後退する。", turn: ["arrow", "L1-4"], s_turn: ["arrow", "L1-4"] },
        { id: "20", td1: ["ホバー・フェザー*", "Hover Feather(QQ)"], td2: "0", td3: "Natural Hover Telemarkの5Q-6Qと同じ。", turn: ["arrow", "fwd"], s_turn: ["arrow", "L1-4"] },
        { id: "15", td1: ["フォーラウェイ・リバース＆スリップ・ピボット*", "Fallaway Reverse & Slip Pivot(SQQS)"], td2: "L3/8 + L1/8 + L1/8 + L1/4 = L7/8 = R1/8", td3: "4歩で左に7/8回転する。", turn: ["arrow", "R1-8"], s_turn: ["arrow", "L1-8"] },
        { id: "11", td1: ["リバース・ウィーヴ(1-4)", "Reverse Weave(SQQS)"], td2: "L3/8", td3: "", turn: ["arrow", "L3-8"], s_turn: ["arrow", "bwd"]  },
        { id: "7", td1: ["ベーシック・ウィーヴ*", "Basic Weave(QQQQQQ)"], td2: "L1/4 + L1/4 = L1/2", td3: "", turn: ["arrow", "R1-8"], s_turn: ["arrow", "fwd"] },
        { id: "19", td1: ["ホバー・テレマーク to PP*", "Hover Telemark to PP(SQQ)"], td2: "L1/4", td3: "3歩目は左足体重", turn: ["arrow", "L1-4"], s_turn: ["arrow", "L1-4"] },
        { id: "21", td1: ["フェザー・エンディング", "Feather Ending(SQQ)"], td2: "L1/8", td3: "男性は、女性のout sideに右足を出す。", turn: ["arrow", "L1-4"], s_turn: ["arrow", "L3-8"]  },
        { id: "3", td1: ["スリー・ステップ*", "Three Step(SQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "L3-8"]  },
        { id: "14", td1: ["ホバー・クロス*", "Hover Cross(SQQ QQQQ)"], td2: "R1/4 + R1/2 + L1/4 = R1/2", td3: "前進・後退を繰り返す。", turn: ["arrow", "bwd"], s_turn: ["arrow", "R1-8"] },
        { id: "22", td1: ["ウィーヴ", "Weave Ending(QQQQ)"], td2: "L7/8 = R1/8", td3: "", turn: ["arrow", "R1-8"], s_turn: ["arrow", "R1-4"]  },
        { id: "23", td1: ["オーバースェイ", "Over Sway(SS)"], td2: "L1/2", td3: "左足に体重を乗せたまま、体を右に傾ける", turn: ["arrow", "L1-4"], s_turn: ["arrow", "fwd"] },
     ],
    }, //end of #3 part
  ]

  /*
  private figures2: Figure[] = [
    {
     title: "フェザー・ステップ Feather Step(SQQ<S>)",
     image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/1FeatherStep-s.jpg?alt=media"
    },
  ]
  */
  
  private contents2: Description2d = {
    id: "2",
    title: "スロー（Slow Foxtrot）：中級コース",
    descriptions: [
      {
        id: "0",
        title: "予備歩 Preposition Step(SSSS)",
        rows: [
          { items: ["1S(S)", "LF to side, wide step", "Body turs to R", "i/e of foot to WF", ""] },
          { items: ["2S", "RF to side,wide step, then brush LF to RF", "Body turn to L", "i/e of foot to WF", ""] },
          { items: ["3S", "LF fwd", "", "HT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [],
        images: [],
      }, // end of id=1
      {
        id: "1",
        title: "フェザー・ステップ Feather Step(SQQ)",
        rows: [
          { items: ["1S", "RF fwd", "", "HT", ""] },
          { items: ["2Q", "LF fwd, L side Leading", "Body turn to R", "T", ""] },
          { items: ["3Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "左手の親指を見ながら踊る。", "2Q→3Qは、左足を乗り越えるように進む。",
              "3Qでは、男性は、女性の右足のOutsideに右足を出す。Reverse系FigureからNatural系Figureに繋げるFigureとして使用される。"
            ]
          }
        ],
        videos: [{ title: "PreBronze Foxtrot: Feather Step", videoId: "uP7wEmwk1NM" }],
        images: [
		    {
		     comment: "フェザー・ステップ Feather Step(SQQ<S>)",
		     src: "1FeatherStep-s.jpg"
		    },
        ],
      }, // end of id=1
      {
        id: "2",
        title: "リバース・ターン＆フェザー・フィニッシュ Reverse Turn & Feather Finish(SQQSQQ)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3, body turn less", "TH", ""] },
          { items: ["4S", "RF back", "Com to turn L", "THT", ""] },
          { items: ["5Q", "LF to side & slightly fwd", "3/8 between 4-5, body turn less", "T", ""] },
          { items: ["6Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "1Sでは、右脇を伸ばすように女性の前進を邪魔するように、左回転をしながら左足を前進させる。",
              "2Qでは、女性は左足を右足に揃えて左にHeel Turnする。",
              "6Qでは、男性は、女性の右足のOutsideに右足を出す。"
            ]
          }
        ],
        videos: [{title: "PreBronze Slow Foxtrot: Reverse Turn and Feather Finish", videoId: "vxWYZnQIgf4"}],
        images: [
		    {
		     comment: "リバース・ターン＆フェザー・フィニッシュ Reverse Turn & Feather Finish(SQQSQQ))",
		     src: "4ReverseTurn-s.jpg"
		    },
        ],
      }, // end of id=2
      {
        id: "3",
        title: "スリー・ステップ Three Step(SQQ)",
        rows: [
          { items: ["1S", "LF fwd", "", "HT", ""] },
          { items: ["2Q", "RF fwd, R side Leading", "Body turn to L", "HT", ""] },
          { items: ["3Q", "LF fwd", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "Reverse系FigureからNatural系Figureに繋げるFigureとして使用される。",
              "2QをHTで踊る点が、Feather Stepと違う事に注意。"
            ]
          }
        ],
        videos: [{title: "PreBronze Slow Foxtrot: Three Step", videoId: "mxvcxAfswu4"}],
        images: [
		    {
		     comment: "スリー・ステップ Three Step(SQQ)",
		     src: "2ThreeStep-s.jpg"
		    },
        ],
      }, // end of id=3
      {
        id: "4",
        title: "ナチュラル・ターン Natural Turn(SQQSSS)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3Q", "RF back", "1/8 between 2-3", "TH", ""] },
          { items: ["4S", "LF back", "Com to turn R", "TH", ""] },
          { items: ["5S", "RF to side, small step(Heel Pull)", "3/8 between 4-5", "H to i/e of foot to Flat", ""] },
          { items: ["6S", "LF fwd", "", "HT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "PreBronze Slow Foxtrot: Natural Turn", videoId: "OWe-aFao-gc" }],
        images: [
		    {
		     comment: "ナチュラル・ターン Natural Turn(SQQSQQ)",
		     src: "3NaturalTurn-s.jpg"
		    },
        ],
      }, // end of id=4
      {
        id: "5",
        title: "クローズド・インピタス＆フェザー・エンディング Closed Impetus & Feather Finish(SQQSQQ)",
        rows: [
          { items: ["1S", "LF back", "Com to turn R", "HT", ""] },
          { items: ["2Q", "RF to closes to LF(Heel Turn)", "3/8 between 1-2", "HT", ""] },
          { items: ["3Q", "LF to side to end side & slightly back", "1/4 between 2-3, body turn less", "TH", ""] },
          { items: ["4S", "RF back", "Com to turn L", "THT", ""] },
          { items: ["5Q", "LF to side & slightly fwd", "1/4 between 4-5, body turn less", "T", ""] },
          { items: ["6Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "PreBronze Slow Foxtrot: Closed Impetus and Feather Finish", videoId: "lQ3Dn4HIWgw" }],
        images: [
		    {
		     comment: "クローズド・インピタス＆フェザー・エンディング Closed Impetus & Feather Finish(SQQSQQ)",
		     src: "5ClosedImpetus-s.jpg"
		    },
        ],
      }, // end of id=5
      {
        id: "6",
        title: "チェンジ・オブ・ダイレクション Change of Direction(SSSS)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2S", "RF diag fwd, R side leading", "1/8 between 1-2", "i/e of TH", ""] },
          { items: ["3S", "LF closes to RF without weight", "1/8 between 2-3", "i/e of T", ""] },
          { items: ["4S", "LF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "左足を出す事から始まる。",
              "90度、左回転する形になる。"
            ]
          },
        ],
        videos: [{ title: "PreBronze Slow Foxtrot: Closed Impetus and Feather Finish", videoId: "lQ3Dn4HIWgw" }],
        images: [
		    {
		     comment: "チェンジ・オブ・ダイレクション Change of Direction(SSSS)",
		     src: "7ChangeOfDirection-s.jpg"
		    },
        ],
      }, // end of id=6
      {
        id: "7",
        title: "ベーシック・ウィーヴ Basic Weave(QQQQQQ)",
        rows: [
          { items: ["1Q", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF to side", "1/8 between 1-2", "T", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3, body turn less  ", "T", ""] },
          { items: ["4Q", "RF back", "Com to turn L", "T", ""] },
          { items: ["5Q", "LF to side & slightly fwd  ", "1/4 between 5-6, body turn less  ", "T", ""] },
          { items: ["6Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "180度、左回転する形になる。",
              "1Q以外は全て爪先（T又はTH）で踊る。"
            ]
          },
        ],
        videos: [{ title: "Bronze Foxtrot: Basic Weave", videoId: "Q5qnpyWMNwA" }],
        images: [
		    {
		     comment: "ベーシック・ウィーヴ Basic Weave(QQQQQQ)",
		     src: "8BasicWeave-s.jpg"
		    },
        ],
      }, // end of id=7
      {
        id: "8",
        title: "バウンス・ファラウェイ・ウィーブ・エンディング Bounce Fallaway with Weave Ending(S&QQQ QQQQ)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "TH", "低く"] },
          { items: ["2&", "RF to side, R side leading", "3/8 between 1-2, body turns less", "T", "低く"] },
          { items: ["3Q", "LF back in CBMP", "", "T", "高く"] },
          { items: ["4Q", "RF to side & slightly back", "Body turn L", "T", "低く"] },
          { items: ["5Q", "LF back in CBMP", "1/8 between 4-5, body turn less", "T", ""] },
          { items: ["6Q", "RF back", "Com to turn L", "T", ""] },
          { items: ["7Q", "LF to side & slightly fwd  ", "1/4 between 7-8, body turn less  ", "T", ""] },
          { items: ["8Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "ワルツのWeaveのように左回転（Reverse Turn）で台形を描く。",
              "全て爪先（T又はTH）で踊る。"
            ],
          },
        ],
        videos: [
          { title: "Foxtrot Bounce Fallaway with Weave Ending", videoId: "mQK7LVUhNRM" },
          { title: "スローフォックストロット バウンスファラウェイ 山嵜組", videoId: "vfGUvi9K4aw" },
          { title: "【スローフォックストロット】バウンスフォーラウェイ 山上組", videoId: "uVu6eHnPhnk" }
        ],
        images: [
		    {
		     comment: "バウンス・ファラウェイ・ウィーブ・エンディング Bounce Fallaway with Weave Ending(S&QQQ QQQQ)",
		     src: "25BawnsFallaway-s.jpg"
		    },
        ],
      }, // end of id=8
      {
        id: "9",
        title: "ナチュラル・ウィーヴ Natural Weave(SQQ QQQQ)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "Almost 1/4 between 1-2", "T", ""] },
          { items: ["3Q", "RF back, R side leading", "Slight turn R between 2-3", "T", ""] },
          { items: ["4Q", "LF back in CBMP", "", "T", ""] },
          { items: ["5Q", "RF back", "Com to turn L", "T", ""] },
          { items: ["6Q", "LF to side & slightly fwd  ", "1/4 between 5-6, body turn less  ", "T", ""] },
          { items: ["7Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "1/4右回転で始まり、1/4左回転で終わるので結果的に向きは変わらない。",
              "1Q以外は全て爪先（T又はTH）で踊る。"
            ]
          }
        ],
        videos: [
          { title: "Bronze Foxtrot: Natural Weave", videoId: "bfRdRJRMdio" },
          { title: "Foxtrot Natural Weave", videoId: "5LrESSdnpyM" }
        ],
        images: [
		    {
		     comment: "ナチュラル・ウィーヴ Natural Weave(SQQ QQQQ)",
		     src: "6NaturalWeave-s.jpg"
		    },
        ],
      }, // end of id=9
      {
        id: "10",
        title: "カーブド・フェザー・ツー・バック・フェザー Curved Feather to Back Feather",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF diag fwd, L side leading", "1/8 between 1-2", "T", ""] },
          { items: ["3Q", "RF fwd in CBMP", "1/8 between 2-3", "TH", ""] },
          { items: ["4S", "LF back in CBMP", "", "TH", ""] },
          { items: ["5Q", "RF back, R side leading", "1/8 between 4-5", "T", ""] },
          { items: ["6Q", "LF back in CBMP", "", "TH", ""] },
          { items: ["7S", "RF back", "Com to turn L", "THT", ""] },
          { items: ["8Q", "LF to side & slightly fwd  ", "1/4 between 7-8, body turn less  ", "T", ""] },
          { items: ["9Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "前半は、3/8右回転で、後半は3/8左回転で終わるので結果的に向きは変わらない。",
              "1Q以外は全て爪先（T又はTH）で踊る。"
            ]
          }
        ],
        videos: [{ title: "Foxtrot Curved Feather to Back Feather", videoId: "XUcLWwpASOI" }],
        images: [],
      }, // end of id=10
      {
        id: "11",
        title: "リバース・ウィーヴ(1-4) Reverse Weave(SQQS)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF to side", "Almost 1/4 between 1-2", "T", ""] },
          { items: ["3Q", "LF back, L side leading", "Slight turn to L between 2-3", "T", ""] },
          { items: ["4Q", "RF back in CBMP", "", "T", ""] },
          { items: ["5Q", "LF back", "Com to turn R", "T", ""] },
          { items: ["6Q", "RF to side & slightly fwd", "1/4 between 5-6, body turns less", "T", ""] },
          { items: ["7Q", "LF fwd in CBMP", "", "TH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [],
        images: [],
      }, // end of id=11
      {
        id: "12",
        title: "リバース・ウェーヴ Reverse Wave(SQQ SQQ SSS)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF to side", "3/8 between 1-2", "T", ""] },
          { items: ["3Q", "LF back", "1/8 between 2-3", "TH", ""] },
          { items: ["4S", "RF back", "1/8 between 3-4", "TH", ""] },
          { items: ["5Q", "LF back", "", "T", ""] },
          { items: ["6Q", "RF back", "", "TH", ""] },
          { items: ["7S", "LF back", "Com to turn R", "TH", ""] },
          { items: ["8S", "RF to side, small step(Heel Pull)", "3/8 between 7-8", "H to i/e of foot to Flat", ""] },
          { items: ["9S", "LF fwd  ", "Body turn to L  ", "HT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "5/8左回転した後、3/8右回転するので、結局、2/8左回転したことになる。",
              "TODO"
            ]
          }
        ],
        videos: [{ title: "Foxtrot Reverse Wave", videoId: "AJMmvjuw1A8" }],
        images: [
		    {
		     comment: "リバース・ウェーヴ Reverse Wave(SQQ SQQ SSS)",
		     src: "19ReverseWave-s.jpg"
		    },
        ],
      }, // end of id=12
      {
        id: "13",
        title: "オープン・テレマーク＆フェザー・エンディング Open Telemark & Feather Ending(SQQ SQQ)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF to side, then brush LF to RF", "1/4 between 1-2", "T", ""] },
          { items: ["3Q", "LF to side", "1/2 between 2-3, body turns less", "TH", ""] },
          { items: ["4S", "RF fwd", "Com to turn L", "HT", ""] },
          { items: ["5Q", "LF fwd, L side Leading  ", "Body turn to R", "T", ""] },
          { items: ["6Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Foxtrot Open Telemark and Feather Ending", videoId: "ozVTkZgXEIo" }],
        images: [
		    {
		     comment: "オープン・テレマーク＆フェザー・エンディング Open Telemark & Feather Ending(SQQ SQQ)",
		     src: "10OpenTelemrkFeather-s.jpg"
		    },
        ],
      }, // end of id=13
      {
        id: "14",
        title: "ホバー・クロス Hover Cross(SQQ QQQQ)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3Q", "RF to side", "1/2 between 2-3, body turns less", "T", ""] },
          { items: ["4Q", "LF fwd in CBMP, small step", "", "T", ""] },
          { items: ["5Q", "Transfer weight back to RF in CBMP", "", "T", ""] },
          { items: ["6Q", "LF to side & slighyly fwd", "1/4 to L between 5-6, body turns less", "T", ""] },
          { items: ["7Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "R 1/4 + R 1/2 + L 1/4 = R 1/2で、最終的に向きが反転する。",
              "最初の3ステップで女性は右にツイストターンをする。"
            ]
          },
        ],
        videos: [
          { title: "Foxtrot Hover Cross", videoId: "ZHfwDOH4HFM" },
          { title: "Hover Cross and Continuous Hover Cross in Foxtrot | Ballroom Dance", videoId: "jkzEWS7UKLA" }
        ],
        images: [
		    {
		     comment: "ホバー・クロス Hover Cross(SQQ QQQQ)",
		     src: "15HoverCross-s.jpg"
		    },
        ],
      }, // end of id=14
      {
        id: "15",
        title: "フォーラウェイ・リバース＆スリップ・ピボット Fallaway Reverse & Slip Pivot(QQQQ)",
        rows: [
          { items: ["1Q", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF back, R side leading", "3/8 between 1-2, body turns less", "T", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3", "TH", ""] },
          { items: ["4Q", "RF back, LF held in CBMP", "1/8 between 3-4, then 1/4 on 4(Pivot)", "THT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "4歩で左に7/8回転するので忙しい。最後はPivot Turnを行う。",
              "L 3/8 + L 1/8 + L 1/8 + L 1/4 = L 7/8 = R 1/8なので左に7/8回転する。"
            ]
          }
        ],
        videos: [
          { title: "Foxtrot Fallaway Reverse and Slip Pivot", videoId: "xylh3g8kPGo" },
          { title: "How to dance Fallaway Slip Pivot & Oversway in Foxtrot - Advanced", videoId: "ih2HAWizELQ" }
        ],
        images: [
		    {
		     comment: "フォーラウェイ・リバース＆スリップ・ピボット Fallaway Reverse & Slip Pivot(QQQQ)",
		     src: "23FallwayRevrsPivot-s.jpg"
		    },
        ],
      }, // end of id=15
      {
        id: "16",
        title: "ダミー dummy(SQQ QQQQ)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "Almost 1/4 between 1-2", "T", ""] },
          { items: ["3Q", "RF back, R side leading", "Slight turn to R between 2-3", "T", ""] },
          { items: ["4Q", "LF back in CBMP", "", "T", ""] },
          { items: ["5Q", "RF back", "Com to turn L", "T", ""] },
          { items: ["6Q", "LF to side & slightly fwd", "1/4 between 5-6, body turns less", "T", ""] },
          { items: ["7Q", "RF fwd in CBMP", "", "TH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Foxtrot Bounce Fallaway with Weave Ending", videoId: "mQK7LVUhNRM" }],
        images: [
		    {
		     comment: "ナチュラル・ウィーブ Natural Weave(SQQ QQQQ)",
		     src: ""
		    },
        ],
      }, // end of id=16
      {
        id: "17",
        title: "ナチュラル・ツイスト・ターン＆ホバー Natural Twist Turn & Hover(SQ&Q SQQ)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "1/4 between 1-2, body turns less", "TH", ""] },
          { items: ["3&", "RF crosses behind LF", "1/8 between 2-3", "T", ""] },
          { items: ["4Q" ,"Twist on both feet, allowing legs to uncross", "", "H of LF / T of RF", ""] },
          { items: ["5S", "End with weight to side on RF(Heel Pull)", "3/8 over 4-5 body turns more", "Flat", ""] },
          { items: ["6Q", "LF diag fwd, L side leading", "", "T", ""] },
          { items: ["7Q", "RF fwd in CBM, OP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Foxtrot Natural Twist Turn", videoId: "c4Kjafc7D9k" }],
        images: [
		    {
		     comment: "ナチュラル・ツイスト・ターン＆ホバー Natural Twist Turn & Hover(SQ&Q SQQ)",
		     src: "20-1NatuTwistTurn-s.jpg"
		    },
        ],
      }, // end of id=17
      {
        id: "18",
        title: "ナチュラル・ホバー・テレマーク Natural Hover Telemark(SQQ SQQ)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2Q", "LF to side", "1/4 between 1-2, body turns less", "TH", ""] },
          { items: ["3Q", "RF to side(Heel Pull)", "1/2 between 2-3", "H to i/e of foot to Flat", ""] },
          { items: ["4S", "L knee veers inward", "Body turns to R", "T of RF, i/e of T of LF", ""] },
          { items: ["5Q", "LF diag fwd, L side leading", "", "T", ""] },
          { items: ["6Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "R 1/4 + R 1/2 = R 3/4 = L 1/4で右に3/4回転する。",
              "前半の3stepは「Hover Cross」と同じである。",
              "4Sでは、左膝を内側に曲げて、右膝に近づける。",
              "5Q-6Qでは、Feather Stepの要領で左サイドリードで前進する。"
            ]
          }
        ],
        videos: [{ title: "Foxtrot Natural Hover Telemark", videoId: "MRrcCmxJ6zM" }],
        images: [
		    {
		     comment: "ナチュラル・ホバー・テレマーク Natural Hover Telemark(SQQ SQQ)",
		     src: "24NatHoverTelemrk-s.jpg"
		    },
        ],
      }, // end of id=18
      {
        id: "19",
        title: "ホバー・テレマーク to PP Hover Telemark(SQQ)",
        rows: [
          { items: ["1S", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF diag fwd, then LF brush toward RF", "1/8 between 1-2, body turns less", "T", ""] },
          { items: ["3Q", "LF side & slightly fwd", "1/8 between 2-3", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Foxtrot Hover Telemark", videoId: "fTa_-wD5-eE" }],
        images: [
		    {
		     comment: "ホバー・テレマーク to PP Hover Telemark(SQQ)",
		     src: "13HoverTelemrk-s.jpg"
		    },
        ],
      }, // end of id=19
      {
        id: "20",
        title: "ホバー・フェザー Hover Feather(QQ)",
        rows: [
          { items: ["1Q", "LF diag fwd, L side leading", "", "T", ""] },
          { items: ["2Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "Natural Hover Telemarkの5Q-6Qと同じである。",
              "TODO"
            ]
          },
        ],
        videos: [{ title: "Foxtrot Hover Feather", videoId: "mjGifHdBSAs" }],
        images: [
		    {
		     comment: "ホバー・フェザー Hover Feather(QQ)",
		     src: "12HoverFeather-s.jpg"
		    },
        ],
      }, // end of id=20
      {
        id: "21",
        title: "フェザー・エンディング Feather Ending(SQQ)",
        rows: [
          { items: ["1S", "RF fwd & across in CBMP", "", "HT", ""] },
          { items: ["2Q", "LF diag fwd", "1/8 to L", "T", ""] },
          { items: ["3Q", "RF fwd in CBMP", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Feather Ending Foxtrot Notes", videoId: "4hcWMk0bDtc" }],
        images: [],
      }, // end of id=21
      {
        id: "22",
        title: "ウィーヴ Weave Ending(QQQQ)",
        rows: [
          { items: ["1Q", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2Q", "RF back, R side leading", "3/8 between 1-2, body turns less", "T", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3", "TH", ""] },
          { items: ["4Q", "RF back, LF held in CBMP", "1/8 between 3-4, then 1/4 on 4(Pivot)", "THT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["L3/8 + L1/8 + L1/8 + L1/4 = L7/8", "TODO"]
          }
        ],
        videos: [
          { title: "How to dance Fallaway Slip Pivot & Oversway in Foxtrot - Advanced", videoId: "ih2HAWizELQ" }
        ],
        images: [],
      }, // end of id=22
      {
        id: "23",
        title: "オーバースェイ Oversway(SS)",
        rows: [
          { items: ["1S", "LF back to end to side", "?", "Closed", "左足を後、横の順に出す"] },
          { items: ["2S", "Flex L knee and incline body to R", "?", "Closed", "ポジションを保ち、右膝を曲げる"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [
          { title: "How to dance Fallaway Slip Pivot & Oversway in Foxtrot - Advanced", videoId: "ih2HAWizELQ" },
        ],
        images: [],
      }, // end of id=23

    ]
  } // end of contents2

  // ====ワルツ=======================
  // 中級クラス用
  waltz_amalgamations2: Comment3[] = [
    {
      title: "中級コース: part #1",
      items: [
        {id: "0", td1: ["予備歩", "Preposition Step(123 123 123 123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "22", td1: ["ラン二ング・スピン・ターン", "Running Spin Turn (123 1&23)"], td2: "", td3: "右足を後退させて終了する", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "23", td1: ["ウィスク・アンド・クイック・ウィング", "Whisk & Quick Wing(12&3)"], td2: "", td3: "左足を後退させて、バック・ウィスクの形からウィングの形に入る。", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "24", td1: ["オープン・テレマーク", "Open Telemark(123)"], td2: "", td3: "左足を前進させて左回転しPPの形で終わる", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン(123)", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "25", td1: ["フォールアウェイ・リバース・アンド・スリップ・ピボット", "Fallaway Reverse & Slip Pivot(1&23)"], td2: "", td3: "左足を前進後、右足を下げて左に回転する。", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "26", td1: ["ランニング", "Running(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "27", td1: ["オーバーターンド・ターニング・ロック", "Overturned Turning Lock(1&23)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "28", td1: ["ナチュラル・ウィーブ", "Natural Weave(1&23 123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "25", td1: ["フォールアウェイ・リバース・アンド・スリップ・ピボット", "Fallaway Reverse & Slip Pivot(1&23)"], td2: "", td3: "左足を前進後、右足を下げて左に回転する。", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "29", td1: ["ダブル・リバース・スピン", "Double Reverse Spin(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["コントラ・チェック～PP", "Contra Check(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ウィング", "Wing(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["プログレス・シャッセ・ツウ・ライト", "Progressive Chasse to Right(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
      ],
    }, //end of #1 part
    {
      title: "中級コース: part #2",
      items: [
        { id: "19", td1: ["LFクローズド・チェンジ", "LF Closed Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "20", td1: ["RFクローズド・チェンジ", "RF Closed Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["リバース・ターン", "Reverse Turn(123 456)"], td2: "L1/4 + L1/8 + L3/8 = L3/4 = R1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["ウィスク", "Whisk(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "R1/4 + R1/8 + R1/2 + R3/8（1/8） = R1/4(0)  ", td3: "初級では元の向きに戻る", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "19", td1: ["LFクローズド・チェンジ", "LF Closed Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "R3/8 + R1/8 = R1/2", td3: "ここではR1/4", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "13", td1: ["ウィング", "Wing(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["プログレッシヴ・シャッセ・ツウ・ライト", "Progressive Chasse to Right(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["ターニング・ロック", "Turning Lock(1&23)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["オーバースェイ", "Oversway(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },

      ],
    }, //end of #2 part
    {
      title: "中級コース: part #3",
      items: [
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "27", td1: ["オーバーターンド・ターニング・ロック", "Overturned Turning Lock(1&23)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ウィング", "Wing(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["プログレス・シャッセ・ツウ・ライト", "Progressive Chasse to Right(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "31", td1: ["バック・ロック", "Back Lock(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "32", td1: ["アウトサイド・スピン", "Outside Spin(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "33", td1: ["ホバー・コルテ", "Hover Corte(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["ウィスク", "Whisk(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "34", td1: ["リバース・ピボット", "Reverse Pivot(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },

        { id: "25", td1: ["フォールアウェイ・リバース・アンド・スリップ・ピボット", "Fallaway Reverse & Slip Pivot(1&23)"], td2: "", td3: "左足を前進後、右足を下げて左に回転する。", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "29", td1: ["ダブル・リバース・スピン", "Double Reverse Spin(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["コントラ・チェック", "Contra Check(123)"], td2: "0", td3: "PPになる", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "オーバースェイのポーズ", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #3 part
  ]

  // 初級クラス用
  waltz_amalgamations: Comment3[] = [
    {
      title: "初級コース: part #1",
      items: [
        {id: "0", td1: ["予備歩", "Preposition Step(123 123 123 123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "R1/4 + R1/8 + R1/2 + R3/8（1/8） = R1/4(0)", td3: "初級では元の向きに戻る", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "2", td1: ["リバース・ターン(456)", "Reverse Turn(456)"], td2: "L 1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["リバース・ターン", "Reverse Turn(123 456)"], td2: "L1/4 + L1/8 + L3/8 = L3/4 = R1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["ウィスク", "Whisk(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン(123)", "Natural Turn(123)"], td2: "R1/4 + R1/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "R1/4 + R1/8 + R1/2 + R3/8（1/8） = R1/4(0)  ", td3: "初級では元の向きに戻る", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "7", td1: ["ターニング・ロック", "Turning Lock(1&23)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["オーバースェイ", "Oversway(123 123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["コントラ・チェック", "Contra Check(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "R1/4 + R1/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "R3/8 + R1/8 = R1/2", td3: "ここではR1/4", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "11", td1: ["ウィーヴ・フロム・PP", "Weave from Promenade Position(123 123)"], td2: "L1/8 + L1/4 + L1/8 + L3/8 =L7/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "R1/4 + R1/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "R1/4 + R1/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["バック・ウィスク", "Back Whisk(123)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ウィング", "Wing(123)"], td2: "L1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["プログレッシヴ・シャッセ・ツウ・ライト", "Progressive Chasse to Right(12&3)"], td2: "L1/8 + L1/8 = L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "15", td1: ["クイック・オープン・リバース", "Quick Open Reverse(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        //{id: "2", td1: ["バック・コルテ(456)*", "Back Corte(456)"], td2: "L 3/8", td3: "3歩目は右足を伸ばす。" },
        { id: "16", td1: ["スローアウェイ・オーバースェイ", "Throwaway Oversway(123 456 789)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ウィーヴ・フロム・PP", "Weave from Promenade Position(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン(123)", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "R3/8 + R1/8 = R1/2", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "17", td1: ["ツイスト・ターン", "Twist Turn(123)"], td2: "R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["シャッセ・フロム・TP", "Chasse from Twist Position(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["シャッセ・フロム・PP", "Chasse from Promenade Position(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["リバース・ターン", "Reverse Turn(456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "19", td1: ["LFクローズド・チェンジ", "LF Closed Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["オープン・インピタス", "Open Impetus(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ウィング", "Wing(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["プログレッシヴ・シャッセ・ツウ・ライト", "Progressive Chasse to Right(12&3)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(123 456)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["ターニング・ロック", "Turning Lock(1&23)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・ターン", "Natural Turn(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["アウトサイド・チェンジ", "Outside Change(123)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["オーバースェイ", "Oversway(123 456)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  }
      ],
    }, //end of #1 part
  ]
  
  private contents3: Description2 = {
    id: "3",
    title: "ワルツ（Waltz）：中級コース&初級コース",
    descriptions: [
      {
        id: "0",
        title: "予備歩 Preposition Step",
        rows: [
          { items: [ "123", "LF to side, wide step", "Body turs to R", "i/e of foot to WF", ""] },
          { items: [ "12", "RF to side,wide step, then brush LF to RF", "Body turn to L", "i/e of foot to WF", ""] },
          { items: [ "3", "LF fwd", "", "HT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=0
      {
        id: "1",
        title: "ナチュラル・スピン・ターン Natural Spin Turn（123 456）",
          rows: [
          { items: ["1", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2", "LF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3", "RF closes to LF", "1/8 between 2-3", "TH", ""] },
          { items: ["4", "LF back & slightly to side, toe turned in", "1/2 to R on 4 (Pivot)", "THT", ""] },
          { items: ["5", "RF fwd in CBMP", "Cont to turn", "HT", ""] },
          { items: ["6", "LF to side & slightly back", "3/8 between 5-6", "HT", "トークAでは1/8 turn"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=1
      {
        id: "2",
        title: "リバース・ターン Reverse Turn（123 456）",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2", "RF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3", "LF closes to RF", "1/8 between 2-3", "TH", ""] },
          { items: ["4", "RF back", "Com to turn L", "TH", ""] },
          { items: ["5", "LF to side", "3/8 between 4-5, body turn less", "T", ""] },
          { items: ["6", "RF closes to LF", "Body complete turn", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=2
      {
        id: "3",
        title: "ウィスク Whisk（123）",
        rows: [
          { items: ["1", "LF fwd", "", "HT", ""] },
          { items: ["2", "RF to side & slightly fwd", "", "T", ""] },
          { items: ["3", "LF closses behind RF", "Body turn to R", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=3
      {
        id: "4",
        title: "シャッセ・フロム・PP Chasse from Promenade Position(12&3)",
        rows: [
          { items: ["1", "RF fwd in CBMP", "", "HT", ""] },
          { items: ["2", "LF to side & slightly fwd", "", "T", ""] },
          { items: ["&", "RF closes to LF", "", "T", ""] },
          { items: ["3", "LF to side & slightly fwd", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=4
      {
        id: "5",
        title: "ナチュラル・ターン Natural Turn(123 456)",
        rows: [
          { items: ["1", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2", "LF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3", "RF closes to LF", "1/8 between 2-3", "TH", ""] },
          { items: ["4", "LF back", "Com to turn R", "TH", ""] },
          { items: ["5", "RF to side", "3/8 between 4-5, body turns less", "T", ""] },
          { items: ["6", "LF closed to RF", "body turns less", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=5
      {
        id: "6",
        title: "アウトサイド・チェンジ Outside Change(123)",
        rows: [
          { items: ["1", "LF back in CBMP", "", "HT", ""] },
          { items: ["2", "RF back", "Com to turn L", "T", ""] },
          { items: ["3", "LF to side & slightly fwd", "1/4 between 2-3, body turns less", "TH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=6
      {
        id: "7",
        title: "ターニング・ロック Turning Lock(1&23)",
        rows: [
          { items: ["1", "RF back, R side leading", "", "T", ""] },
          { items: ["&", "LF crosses in front of RF", "", "T", ""] },
          { items: ["2", "RF back & slightly rightward", "Com to turn L", "T", ""] },
          { items: ["3", "LF to side & slightly fwd", "1/4 between 2-3, body turns less", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=7
      {
        id: "8",
        title: "オーバースェイ Oversway(123 456)",
        rows: [
          { items: ["1", "右にOverswayをする", "", "", ""] },
          { items: ["2", "右にOverswayをする", "", "", ""] },
          { items: ["3", "右にOverswayをする", "", "", ""] },
          { items: ["4", "右にOverswayをする", "", "", ""] },
          { items: ["5", "左足を右足にブラシする", "", "", ""] },
          { items: ["6", "左足を右足に揃える", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=8
      {
        id: "9",
        title: "コントラ・チェック Conta Check(123)",
        rows: [
          { items: ["1", "LF fwd in CBMP, split weight", "1/8 to L, body turns more", "HF", ""] },
          { items: ["2", "Transfer weight to RF, then brush LF to RF", "1/8 to R, body turns more", "T", ""] },
          { items: ["3", "LF to side", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=9
      {
        id: "10",
        title: "オープン・インピタス Open Impetus(123)",
        rows: [
          { items: ["1", "LF back", "Com to turn R", "TH", ""] },
          { items: ["2", "RF closes to LF (Heel Turn)", "3/8 between 1-2", "HT", ""] },
          { items: ["3", "LF to side", "1/8 between 2-3", "HT", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=10
      {
        id: "11",
        title: "ウィーヴ・フロム・PP Weave from Promenade Position(123 456)",
        rows: [
          { items: ["1", "RF fwd & across in CBMP", "1/8 to L before 1 (RF)", "HT", ""] },
          { items: ["2", "LF fwd", "Cont to turn L", "T", ""] },
          { items: ["3", "RF to side & slightly back", "1/4 between 2-3", "TH", ""] },
          { items: ["4", "LF back in CBMP", "1/8 between 3-4, body turns less", "TH", ""] },
          { items: ["5", "RF back", "Cont to turn L", "T", ""] },
          { items: ["6", "LF to side & slightly fwd", "3/8 between 5-6, body turns less", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=11
      {
        id: "12",
        title: "バック・ウィスクBack Whisk(123)",
        rows: [
          { items: ["1", "LF back", "", "TH", ""] },
          { items: ["2", "RF diag back", "", "T", ""] },
          { items: ["3", "LF crosses behind RF", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=12
      {
        id: "13",
        title: "ウィング Wing(123)",
        rows: [
          { items: ["1", "RF fwd across in CBMP", "1/8 to L (RF)", "HT", ""] },
          { items: ["2", "Draw LF toward RF", "Com to turn body to L", "Flat", ""] },
          { items: ["3", "LF closes to RF without weight", "Cont to turn body to L", "Flat", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=13
      {
        id: "14",
        title: "プログレッシヴ・シャッセ・ツウ・ライト Progressive Chasse to Right(12&3)",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "HT", ""] },
          { items: ["2", "RF to side", "1/8 between 1-2", "T", ""] },
          { items: ["&", "LF closes to RF", "1/8 between 2-3, body turns less", "T", ""] },
          { items: ["3", "RF to side & slightly back", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=14
      {
        id: "15",
        title: "クイック・オープン・リバース Quick Open Reverse(1&23)",
        rows: [
          { items: ["1", "RF fwd", "?", "?", ""] },
          { items: ["&", "LF fwd", "?", "?", ""] },
          { items: ["2", "RF Side", "?", "?", ""] },
          { items: ["3", "LF Back", "?", "?", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=15
      {
        id: "16",
        title: "スローアウェイ・オーバースェイ Throwaway Oversway(123 456 789)",
        rows: [
          { items: ["1", "上半身を回転させる。", "?", "?", ""] },
          { items: ["2", "（同上）", "?", "?", ""] },
          { items: ["3", "（同上）", "?", "?", ""] },
          { items: ["4", "上半身を元に戻す。", "?", "?", ""] },
          { items: ["5", "（同上）", "?", "?", ""] },
          { items: ["6", "（同上）", "?", "?", ""] },
          { items: ["7", "体重を右足に乗せる。", "?", "?", ""] },
          { items: ["8", "左足を右足にブラシする。", "?", "?", ""] },
          { items: ["9", "右足に体重を乗せ、左足はポイントする。", "?", "?", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
       ],
        videos: []
      }, // end of id=16
      {
        id: "17",
        title: "ツイスト・ターン Twist Turn(123)",
        rows: [
          { items: ["1", "RF crosses behind LF slightly back", "Com to turn R", "?", ""] },
          { items: ["2", "Twist on both feet", "3/8 on steps 1-2. Body turns slightly more.", "?", ""] },
          { items: ["3", "LF fwd", "?", "?", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=17
      {
        id: "18",
        title: "シャッセ・フロム・TP Chasse from Twist Position(12&3)",
        rows: [
          { items: ["1", "RF fwd in CBMP", "", "HT", ""] },
          { items: ["2", "LF to side & slightly fwd", "", "T", ""] },
          { items: ["&", "RF crosses behine LF", "", "T", "顔を右に向ける"] },
          { items: ["3", "LF to side & slightly fwd", "", "TH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=18
      {
        id: "19",
        title: "LFクローズド・チェンジ RF Closed Change(123)",
        rows: [
          { items: ["1", "RF fwd", "", "HT", ""] },
          { items: ["2", "LF to side & slightly fwd", "", "T", ""] },
          { items: ["3", "RF closes to LF", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=19
      {
        id: "20",
        title: "RFクローズド・チェンジ RF Closed Change(123)",
        rows: [
          { items: ["1", "LF fwd", "", "HT", ""] },
          { items: ["2", "RF to side & slightly fwd", "", "T", ""] },
          { items: ["3", "LF closes to RF", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=20
      {
        id: "21",
        title: "バック・コルテ Back Corte(123)",
        rows: [
          { items: ["1", "RF back", "Com to turn L", "TH", ""] },
          { items: ["2", "LF to side & slightly fwd", "3/8 between 1-2", "T", ""] },
          { items: ["3", "Transfer weight to RF(LF)", "", "TH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=21
      {
        id: "22",
        title: "ランニング・スピン・ターン Running Spin Turn(123 4&56)",
        rows: [
          { items: ["1", "RF fwd", "Com to turn R", "HT", ""] },
          { items: ["2", "LF to side", "1/4 between 1-2", "T", ""] },
          { items: ["3", "RF closes to LF", "1/8 between 2-3", "TH", ""] },
          { items: ["4", "LF back & slightly to side, toe turned in", "1/2 to R on 4 (Pivot)", "THT", ""] },
          { items: ["&", "RF fwd", "1/8 between &", "HT", ""] },
          { items: ["5", "LF fwd in CBMP", "Cont to turn", "HT", ""] },
          { items: ["6", "RF to side & slightly back", "3/8 between 5-6", "HT", "トークAでは1/8 turn"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["後半の4&56で右に360度回転する。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=22
      {
        id: "23",
        title: "ウィスク・アンド・クイック・ウィング Whisk & Quick Wing(12&3)",
        rows: [
          { items: ["1", "LF crosses behind RF", "", "TH", ""] },
          { items: ["2", "RF fwd across in CBMP", "", "HT", ""] },
          { items: ["&", "Draw LF toward RF", "", "Flat", ""] },
          { items: ["3", "LF closes to RF without weight", "", "Flat", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["バック・ウィスクの形からウィングの形に入る。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=23
      {
        id: "24",
        title: "オープン・テレマーク Open Telemark(123)",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "TH", ""] },
          { items: ["2", "RF to side", "Just under 3/8 between 1-2", "T", ""] },
          { items: ["3", "LF to side", "Just over 3/8 between 2-3, body turns less", "TH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["左足を女性のアウトサイドに前進させて左回転しPPの形で終わる。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=24
      {
        id: "25",
        title: "フォールアウェイ・リバース・アンド・スリップ・ピボット Fallaway Reverse & Slip Pivot(1&23)",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "TH", ""] },
          { items: ["&", "RF back, R side leading", "3/8 between 1-2, body turns less", "T", ""] },
          { items: ["2", "LF back in CBMP", "1/8 between 2-3", "TH", ""] },
          { items: ["3", "RF back, LF held in CBMP", "1/8 between 3-4, then 1/4 on 4 (Pivot)", "THT", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["左足を女性のアウトサイドに前進させて左回転しPPの形で終わる。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=25
      {
        id: "26",
        title: "ランニング Running(12&3)",
        rows: [
          { items: ["1", "LF fwd", "", "", ""] },
          { items: ["2", "RF fwd to side", "", "", ""] },
          { items: ["&", "LF closes to RF", "", "", ""] },
          { items: ["3", "LF fwd", "", "", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["左足を女性のアウトサイドに前進させて左回転しPPの形で終わる。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=26
      {
        id: "27",
        title: "オーバーターンド・ターニング・ロック Overturned Turning Lock(1&23)",
        rows: [
          { items: ["1", "RF back, R side leading", "", "", "T"] },
          { items: ["&", "LF crosses in front of RF", "", "", "T"] },
          { items: ["2", "RF back & slightly rightward", "Com to turn L", "", "T"] },
          { items: ["3", "LF to side & slightly fwd", "1/4 between 2-3, body turns less", "", "TH"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["左足を女性のアウトサイドに前進させて左回転しPPの形で終わる。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=27
      {
        id: "28",
        title: "ナチュラル・ウィーブ Natural Weave(1&23 123)",
        rows: [
          { items: ["1", "RF fwd", "Com to turn R", "", "HT"] },
          { items: ["&", "LF to side", "Almost 1/4 between 1-2", "", "T"] },
          { items: ["2", "RF back, R side leading", "Slight turn to R between 2-3", "", "T"] },
          { items: ["3", "LF back in CBMP", "", "", "T"] },
          { items: ["4", "RF back", "Com to turn L", "", "T"] },
          { items: ["5", "LF to side & slightly fwd", "1/4 between 5-6, body turns less", "", "T"] },
          { items: ["6", "RF fwd in CBMP", "", "", "TH"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["スローの場合と同じステップか？", "TODO"]
          }
        ],
        videos: []
      }, // end of id=28
      {
        id: "29",
        title: "ダブル・リバース・スピン Double Reverse Spin(12&3)",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "", "HT"] },
          { items: ["2", "RF to side", "1/4 between 1-2", "", "T"] },
          { items: ["&", "LF closes to RF without weight (Toe Pivot)", "3/8 between 2-3", "", "T(LF)"] },
          { items: ["3", "Hold weight on RF", "1/4 between 3-4", "", "TH (RF)"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=29
      {
        id: "30",
        title: "プログレス・シャッセ・トウ・ライト Progressive Chasse to Right(12&3))",
        rows: [
          { items: ["1", "LF fwd", "Com to turn L", "", "HT"] },
          { items: ["2", "RF to side", "1/8 between 1-2", "", "T"] },
          { items: ["&", "LF closes to RF", "1/8 between 2-3, body turns less", "", "T"] },
          { items: ["3", "RF to side & slightly back", "", "", "TH (RF)"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=30
      {
        id: "31",
        title: "バック・ロック Back Lock(12&3)",
        rows: [
          { items: ["1", "LF back in CBMP", "", "", "TH"] },
          { items: ["2", "RF back", "", "", "T"] },
          { items: ["&", "LF crosses in front of RF", "", "", "T"] },
          { items: ["3", "RF diag back", "", "", "TH"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=31
      {
        id: "32",
        title: "アウトサイド・スピン Outside Spin(123 456)",
        rows: [
          { items: ["1", "LF back in CBMP, small step with toe turned in", "3/8 to R on 1 (Pivot)", "", "THT"] },
          { items: ["2", "RF fwd in CBMP", "Body turn to R", "", "TH"] },
          { items: ["3", "LF to side, pivotting to end LF back", "3/8 between 2-3, then an additional 3/8 on 3 (Pivot)", "", "TH"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=32
      {
        id: "33",
        title: "ホバー・コルテ Hover Corte(123)",
        rows: [
          { items: ["1", "RF back", "Com to turn L	", "", "TH"] },
          { items: ["2", "LF to side & slightly fwd", "3/8 between 1-2", "", "T"] },
          { items: ["3", "Transfer weight to RF", "", "", "TH"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=33
      {
        id: "34",
        title: "リバース・ピボット Reverse Pivot(12&3)",
        rows: [
          { items: ["&", "RF back in CBMP, small step with toe turned in", "1/2 to L", "", "THT"] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=34

    ]
  }; // end of contents3

  // ====タンゴ=============================================
  tango_amalgamations2: Comment3[] = [
    {
      title: "中級コース: #1 part",
      items: [
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "32", td1: ["フォーラウェイ・リバース＆スリップ・ピボット", "Fallaway Reverse & Slip Pivot(QQQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "35", td1: ["（シンコペーテッド）ベーシンク・リバース・ターン", "Basic Reverse Turn(QQSQQS又はQQ&QQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["コントラ・チェック", "Contra Check(SQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "20", td1: ["ザ・チェイス", "The Chase(SQQQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ナチュラル・プロムナード・ターン", "Natural Promenade Turn(SQQS)"], td2: "R3/8 + R3/8 = R3/4 = L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "34", td1: ["PSS・リバースターン", "Progressive Side Step Reverse Turn(QQSS QQSS QQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ロック・バック・オン・RF", "Rock back on Right Foot（QQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["バック・コルテ", "Back Corte(SQQS)"], td2: "R1/8 + L1/4 = L1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "33", td1: ["フォー・ステップ", "Four Step(QQQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ウォーク・リンク", "Walk Link（SSQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ネック・リンク", "Neck Link（&S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "37", td1: ["バック・オープン・プロムナード", "Back Open Promenade（SQQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "36", td1: ["リバース・アウトサイド・スイブル", "Reverse Outside Swivel（QQSQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "28", td1: ["ブラシ・タップ", "Brush Tap(QQ&S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #1 part
    {
      title: "中級コース: #2 part",
      items: [
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ファイブ・ステップ", "Five Step(QQQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ツイスト", "Twist（SQQQQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "32", td1: ["フォーラウェイ・リバース＆スリップ・ピボット", "Fallaway Reverse & Slip Pivot(QQQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ベェニーズ・ターン・オーバースウェイ", "Benny's Turn Oversway（QQ& QQ& QQ& QQ& SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ランジ～PP", "Same Foot Lunge（SQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "29", td1: ["プロムナード・リンク ", "Promenade Link(SQQ)"], td2: "0", td3: "左足を右足にクロスさせる", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "33", td1: ["フォー・ステップ", "Four Step(QQQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "32", td1: ["フォーラウェイ・リバース＆スリップ・ピボット", "Fallaway Reverse & Slip Pivot(QQQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["ウィスク", "Whisk（QQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["戻す・Xライン", "Return X-Line（QQ SSS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "??", td1: ["左足ポイント～PP", "Left Foot Point（&S &S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "29", td1: ["プロムナード・リンク ", "Promenade Link(SQQ)"], td2: "0", td3: "左足を右足にクロスさせる", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "2", td1: ["プログレッシブ・リンク", "Progressive Link(QQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "24", td1: ["チェイス", "Chase(SQQQQ Q&Q QQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["プログレッシブ・リンク", "Progressive Link(QQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "37", td1: ["バック・オープン・プロムナード", "Back Open Promenade（SQQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "36", td1: ["リバース・アウトサイド・スイブル", "Reverse Outside Swivel（QQSQQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #2 part
    {
      title: "中級コース: #3 part",
      items: [
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "32", td1: ["フォーラウェイ・リバース＆スリップ・ピボット", "Fallaway Reverse & Slip Pivot(QQQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["オーバースウェイ", "Oversway(QQSS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["プログレッシブ・リンク", "Progressive Link(QQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ナチュラル・プロムナード・ターン", "Natural Promenade Turn(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["ロック・ターン", "Rock Turn(QQS QQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ファイブ・ステップ", "Five Step(QQQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "20", td1: ["ザ・チェイス", "The Chase(SQQQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "0", td1: ["ポーズ", "Pause(S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #3 part

  ]

  tango_amalgamations: Comment3[] = [
    {
      title: "初級コース: #1 part",
      items: [
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "L1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["プログレッシブ・リンク", "Progressive Link(QQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["バック・コルテ", "Back Corte(SQQS)"], td2: "R1/8 + L1/4 = L1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["ウォーク", "Walks(SS)"], td2: "L1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["オープン・リバース・ターン", "Open Reverse Turn, Lady Outside(QQSQQS)"], td2: "L1/4 + L1/8 + L3/8 = L3/4 = R1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["プログレッシブ・リンク", "Progressive Link(QQ)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ナチュラル・プロムナード・ターン", "Natural Promenade Turn(SQQS)"], td2: "R3/8 + R3/8 = R3/4 = L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["ロック・ターン", "Rock Turn(SQQSQQS)"], td2: "R1/8 + R1/8 + L1/4 = 0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        //{ id: "10", td1: ["ベーシック・リバース・ターン(456)", "Basic Reverse Turn(QQS)"], td2: "L3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ファイブ・ステップ", "Five Step(QQQQS)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["ナチュラル・ツイスト・ターン", "Natural Twist Turn(SQQSQQ)"], td2: "R1/4 + R1/8 + R5/8 = R1/1で1回転する。", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ト・スロー", "To Slow(&S)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["ファラウェイ・プロムナード", "Fallaway Promenade(SQQSQQ)"], td2: "R3/8 + L1/4 = R1/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "15", td1: ["ファラウェイ・フォア・ステップ", "Fallaway Four Step(QQQQ)"], td2: "L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        //{ id: "16", td1: ["セイム・フート・ランジ", "Same Foot Lunge(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "30", td1: ["右サイド・オーバースウェイ*", " Oversway(QQSS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "17", td1: ["アウトサイド・スイベル", "Outside Swivel(SS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["コントラ・チェック", "Contra Check(SQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "19", td1: ["スリップ・ピボット(34)", "Slip(Sliding) Pivot(QQ)"], td2: "L1/8 + L1/8 + L1/4 = L1/2", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["ナチュラル・ツイスト・ターン(456)", "Natural Twist Turn(SQQSQQ)"], td2: "R1/8 + R5/8 = R3/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ト・スロー", "To Slow(&S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        //{ id: "12", td1: ["ナチュラル・ツイスト・ターン", "Natural Twist Turn(SQQSQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        //{ id: "27", td1: ["シャッセ・ツー・レフト", "Chasse to Left(QQ&Q)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "31", td1: ["ツイスト＆シャッセ・ツー・レフト*", "Twist & Chasse to Left*(SQQSQ&Q)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["ナチュラル・ツイスト・ターン", "Natural Twist Turn(SQQSQQ)"], td2: "R1/4 + R1/8 + R5/8 = R1/1で1回転する。", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "22", td1: ["X-ライン", "X-Line(????)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["オーバースウェイ", "Oversway(QQSS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "23", td1: ["フリッカー", "Flicker(QQQ&QS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["オーバースウェイ", "Oversway(QQSS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "24", td1: ["チェイス", "Chase(SQQQQ Q&Q QQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["クローズド・プロムナード", "Closed Promenade(SQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ファイブ・ステップ", "Five Step(QQQQS)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["ト・スロー", "To Slow(&S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "25", td1: ["ストーキング・ウォーク", "Stalking Walks(S&SS&S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "25", td1: ["ストーキング・ウォーク", "Stalking Walks(S&SS&S)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "23", td1: ["フリッカー", "Flicker(QQQ&QS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "26", td1: ["シャッセ・ツー・ライト", "Chasse to Right(QQ&Q)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "29", td1: ["プロムナード・リンク ", "Promenade Link(SQQ)"], td2: "0", td3: "左足を右足にクロスさせる", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] },
        { id: "18", td1: ["コントラ・チェック", "Contra Check(SQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["オーバースウェイ", "Oversway(QQSS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["オーバースウェイ", "Oversway(QQSS)"], td2: "L1/4 + L1/8 + L1/4 = L5/8 = R3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ナチュラル・プロムナード・ターン", "Natural Promenade Turn(SQQS)"], td2: "R3/8 + R3/8 = R3/4 = L1/4", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["ベーシック・リバース・ターン(456)", "Basic Reverse Turn(QQS)"], td2: "L3/8", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ファイブ・ステップ", "Five Step(QQQQS)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "0", td1: ["最後の踊り", "???"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #1 part
  ]
  
  private contents4: Description2 = {
    id: "4",
    title: "タンゴ（Tango）：中級コース&初級コース",
    descriptions: [
      {
        id: "1",
        title: "ウォーク Walks（SS）",
        rows: [
          { items: ["1S", "LF fwd in CBMP", "1/8 to L before step 1", "HF", ""] },
          { items: ["2S", "RF fwd, R side leading", "", "HF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["1Sでは左カーブをする。", "TODO"]
          }
        ],
        videos: []
      }, // end of id=1
      {
        id: "2",
        title: "プログレッシブ・リンク Progressive Link(QQ)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back, L knee veering inward", "Body turn to R", "i/e of WF (RF), i/e of B (LF)", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "1Qで2Qまでの動作を一瞬に行う積りになる事。",
              "2Qでは体を右回転させながら、左膝を内側に絞る事。"
            ]
          }
        ],
        videos: []
      }, // end of id=2
      {
        id: "3",
        title: "クローズド・プロムナード Closed Promenade(SQQS)",
        rows: [
          { items: ["1S", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBMP", "", "HF", ""] },
          { items: ["3Q", "LF to side & slightly fwd", "", "i/e of WF", ""] },
          { items: ["4S", "RF closes to LF, slightly behind", "Body turn to L", "WF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=3
      {
        id: "4",
        title: "バック・コルテ Back Corte(SQQS)",
        rows: [
          { items: ["1S", "LF to side, turning shoulders strongly to R", "1/8 to R", "i/e of BH", ""] },
          { items: ["2Q", "RF back in CBMP", "1/8 to R between 1-2, body turns less", "BH", ""] },
          { items: ["3Q", "LF to side & slightly fwd", "1/4 to L between 5-6, body turns less", "i/e of WF", ""] },
          { items: ["4S", "RF closes to LF, slightly behind", "Body completes turn", "WF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["1Sでは、後退する左足をR1/8に向ける。", "TODO"]
          }
        ],
        videos: [{ title: "PreBronze Tango: Back Corte", videoId: "GS2-rJWaDUU" }]
      }, // end of id=4
      {
        id: "5",
        title: "オープン・リバース・ターン Open Reverse Turn, Lady Outside(QQSQQS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side", "1/4 between 1-2", "BH", ""] },
          { items: ["3S", "LF back in CBMP", "1/8 between 2-3, body turns less", "BH", ""] },
          { items: ["4Q", "RF back", "Body completes turn", "BH", ""] },
          { items: ["5Q", "LF to side & slightly fwd", "3/8 between 4-5, body turns less", "i/e of WF", ""] },
          { items: ["6S", "RF closes to LF, slightly behind", "Body completes turn", "WF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "PreBronze Tango: Open Reverse Turn, Lady Outside", videoId: "ZSjSVsmQjxE" }]
      }, // end of id=5
      {
        id: "6",
        title: "ナチュラル・プロムナード・ターン Natural Promenade Turn(SQQS)",
        rows: [
          { items: ["1S", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBMP", "Com to turn R", "HF", ""] },
          { items: ["3Q", "LF to side & slightly back", "3/8 to R between 2-3", "BHB", ""] },
          { items: ["4S", "RF fwd, then place LF to side", "3/8 to R between 3-4, body turns more", "HF (RF), i/e of B (LF)", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Bronze Tango: Natural Promenade Turn", videoId: "14z-4D5Qh9M" }]
      }, // end of id=6
      {
        id: "7",
        title: "LF ロック LF Rock(QQS)",
        rows: [
          { items: ["1Q", "LF back, L side leading", "", "i/e of BH", ""] },
          { items: ["2Q", "Transfer weight to RF, R side leading", "", "HF", ""] },
          { items: ["3S", "LF back, small step, L side leading", "", "i/e of BH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Bronze Tango: Rock Back on Left Foot", videoId: "yAx92Jw2Yck" }]
      }, // end of id=7
      {
        id: "8",
        title: "RF ロック RF Rock(QQS)",
        rows: [
          { items: ["1Q", "RF back", "", "BH", ""] },
          { items: ["2Q", "Transfer weight to LF in CBMP", "", "HF", ""] },
          { items: ["3S", "RF back, small step", "", "i/e of BH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Bronze Tango: Rock Back on Right Foot", videoId: "A4Dk_EojSm0" }]
      }, // end of id=8
      {
        id: "9",
        title: "ロック・ターン Rock Turn(SQQSQQS)",
        rows: [
          { items: ["1S", "RF fwd", "Com to turn R", "HF", ""] },
          { items: ["2Q", "LF to side & slightly back", "1/8 between 1-2", "i/e of BH", ""] },
          { items: ["3Q", "Transfer weight to RF, R side leading", "1/8 between 2-3", "WF", ""] },
          { items: ["4S", "LF back, small step, turning shoulders strongly to R", "", "i/e of BH", ""] },
          { items: ["5Q", "RF back", "Com to turn L", "BH", ""] },
          { items: ["6Q", "LF to side & slightly fwd", "1/4 between 5-6, body turns less", "i/e of WF", ""] },
          { items: ["7S", "RF closes to LF, slightly behind", "Body completes turn", "WF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "PreBronze Tango: Rock Turn", videoId: "q4jeimBtQMw" }]
      }, // end of id=9
      {
        id: "10",
        title: "ベーシック・リバース・ターン Basic Reverse Turn(QQSQQS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2", "BH", ""] },
          { items: ["3S", "LF crosses in front of RF", "1/8 between 2-3, body turns less", "WF", ""] },
          { items: ["4Q", "RF back", "Body completes turn", "BH", ""] },
          { items: ["5Q", "LF to side & slightly fwd", "3/8 between 4-5, body turns less", "i/e of WF", ""] },
          { items: ["6S", "RF closes to LF, slightly behind", "Body completes turn", "WF", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=10
      {
        id: "11",
        title: "ファイブ・ステップ Five Step(QQQQS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2", "BH", ""] },
          { items: ["3Q", "LF back in CBMP", "", "BH", ""] },
          { items: ["4Q", "RF back & slightly rightward", "", "BH", ""] },
          { items: ["5S", "Place LF to side in PP without weight", "Body turn to R", "i/e of B", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: []
      }, // end of id=11
      {
        id:"12",
        title: "ナチュラル・ツイスト・ターン Natural Twist Turn(SQQSQQ)",
        rows: [
          { items: ["1S", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBMP", "Com to turn R", "HF", ""] },
          { items: ["3Q", "LF to side", "1/4 to R", "BH", ""] },
          { items: ["4S", "Cross RF behind LF, split weight", "1/8 to R, body turns more", "B", ""] },
          { items: ["5Q", "With weight on both feet, twist to R, allowing feet to uncross", "", "B (RF), H (LF)", ""] },
          { items: ["6Q", "End with weight on RF", "5/8 over 5-6", "Flat (RF), i/e of B (LF)", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "R1/4 + R1/8 + R5/8 = R1/1で1回転する。",
              "男性の3歩目は、女性のボディに近過ぎず離れ過ぎず、中央斜めに背面する位置に入る。ただし視線は進行方向を保つ。"
            ]
          }
        ],
        videos: []
      }, // end of id=12
      {
        id: "13",
        title: "ト・スロー To Slow(&S)",
        rows: [
          { items: ["1&", "腰を右回転させながら、左膝を内側に絞る", "Body turn to R", "?", ""] },
          { items: ["2S", "右回転させた腰を元の位置に戻す", "Body turn to L", "?", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "1Sでは、腰を右回転させながら、左膝を内側に絞る。",
              "2&では、右回転させた腰を元の位置に戻す。"
            ]
          }
        ],
        videos: []
      }, // end of id=13
      {
        id: "14",
        title: "ファラウェイ・プロムナード Fallaway Promenade(SQQSQQ)",
        rows: [
          { items: ["1S", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBMP", "", "HF", ""] },
          { items: ["3Q", "LF to side", "3/8 to R between 2-3", "BH", ""] },
          { items: ["4S", "RF back, R side leading", "", "i/e of BH", ""] },
          { items: ["5Q", "LF back in CBMP", "1/4 to L between 4-5", "BH", ""] },
          { items: ["6Q", "RF closes to LF, slightly behind", "Body completes turn", "BH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=14
      {
        id: "15",
        title: "ファラウェイ・フォア・ステップ Fallaway Four Step(QQQQ)",
        rows: [
          { items: ["1Q", "LF back in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2, body turns less", "BH", ""] },
          { items: ["3Q", "LF back in CBMP", "", "BH", ""] },
          { items: ["4Q", "Close RF slightly behind LF", "", "i/e of BH", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=15
      {
        id: "16",
        title: "セイム・フート・ランジ Same Foot Lunge(SS)",
        rows: [
          { items: ["1S", "右足体重で左足を伸ばす。女性も男性と同じ方向を向いて左足を伸ばす。", "", "", ""] },
          { items: ["2S", "体重を左足にかける。女性は左足を軸に左回転して男性と正対する。", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: [
          { title: "Same Foot Lunge", videoId: "lzp9Qq9Ceoc" },
          { title: "タンゴ セイムフットランジ 山上組", videoId: "i89-Q6hg578" },
          { title: "セイムフットランジ おうちレッスン 男子のポイント", videoId: "ibkXXtIoVh8" }
        ]
      }, // end of id=16
      {
        id: "17",
        title: "アウトサイド・スイベル Outside Swivel(SS)",
        rows: [
          { items: ["1S", "男性は、左足を後に下げる。男性と女性が、お互いに右足を前で左足が後ろの形で背面状態にする（パートナー・アウトサイド状態）。", "", "", ""] },
          { items: ["2S", "男性は、下げていた左足を元に戻す。この時、女性は右足を軸に回転してスイベル(Swivel)を行い男性と正対する。", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "男性と女性が、お互いに右足を前で左足が後ろの形で背面状態にある時、アウトサイド状態になっている。",
              "アウトサイド状態にある女性が右足を軸に回転して正対する事をスイベル(Swivel)と言う。"
            ]
          }
        ],
        videos: [
          { title: "タンゴのステップ アウトサイドスイブル 群馬県の社交ダンス教室", videoId: "jVgRAR_Q3eI" }
        ],
      }, // end of id=17
      {
        id: "18",
        title: "コントラ・チェック Contra Check(SQQ)",
        rows: [
          { items: ["1S", "LF fwd in CBMP, knees flexed", "Strong body turn to L", "HF", ""] },
          { items: ["2Q", "Transfer weight to RF", "Slight body turn to R", "BH", ""] },
          { items: ["3Q", "Place LF to side without weight, knee veering inward", "Body turn to R", "i/e of B", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=18
      {
        id: "19",
        title: "フォラウェイ・リバース＆スリップ・ピボット Fallaway Reverse & Slip Pivot(QQQQ)",
        rows: [
          { items: ["1Q", "LF fwd", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF back, R side leading", "3/8 between 1-2, body turns less", "BH", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3", "BH", ""] },
          { items: ["4Q", "RF back, LF held in CBMP", "1/8 between 3-4, then 1/4 on 4 (Pivot)", "BHB", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=19
      {
        id: "20",
        title: "ザ チェイス The Chase(SQQQQS)",
        rows: [
          { items: ["1S", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBMP", "", "HF", ""] },
          { items: ["3Q", "LF to side & slightly fwd", "1/8 to R between 2-3", "i/e of BH", "" ] },
          { items: ["4Q", "RF fwd in CBMP", "1/8 to R between 3-4", "BH", ""] },
          { items: ["5Q", "LF back in CBMP", "1/8 to R between 4-5", "BH", ""] },
          { items: ["6S", "RF to side & slightly fwd, small step, then place LF to side, knee veering inward", "3/8 to R between 5-6, body turns more", "BH (RF), i/e of B (LF)", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=20
      {
        id: "21",
        title: "オーバースウェイ Oversway(QQSS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side", "1/4 between 1-2", "BH", ""] },
          { items: ["3S", "LF back to end to side", "1/8 between 2-3, then a further 1/4 on 3", "i/e of BH", ""] },
          { items: ["4S", "Flex L knee and incline body to R", "", "BH", "WF (LF), i/e of B (RF)"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          }
        ],
        videos: [{ title: "Tango Oversway", videoId: "1SgRywyPC34" }]
      }, // end of id=21
      {
        id: "22",
        title: "X-ライン X-Line(???)",
        rows: [
          { items: ["1Q", "", "Com to turn L", "HF", ""] },
          { items: ["2Q", "", "1/4 between 1-2", "BH", ""] },
          { items: ["3Q", "", "1/8 between 2-3, then a further 1/4 on 3", "i/e of BH", ""] },
          { items: ["4Q", "", "", "BH", "WF (LF), i/e of B (RF)"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          }
        ],
        videos: [{ title: "Intermediate: Tango: Man variations (Quarter Beats - X Line - Ronde etc)", videoId: "BGs_un9zAFs" }]
      }, // end of id=22
      {
        id: "23",
        title: "フリッカー Flicker(QQQ&QS)",
        rows: [
          { items: ["1Q", "左足体重で立ち、右足の膝を曲げて腰を右に回す。", "", "", ""] },
          { items: ["2Q", "左足体重で立ち、右足の膝を曲げて腰を元に戻す。", "", "", ""] },
          { items: ["3Q", "右足を前に出す。", "", "", ""] },
          { items: ["4&", "左足を右足の後に出す。", "", "", ""] },
          { items: ["5Q", "右足を前に出す。", "", "", ""] },
          { items: ["6S", "右体重のまま、左足を前に出す（ポイント）。", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          },
        ],
        videos: []
      }, // end of id=23
      {
        id: "24",
        title: "チェイス Chase(SQQQQQ&QQQ)",
        rows: [
          { items: ["1S", "左足を出し、PPで前進する。", "", "", ""] },
          { items: ["2Q", "右足を女性のアウトサイドに出す。", "Com to turn R", "", ""] },
          { items: ["3Q", "左足を横に出し、女性と正対する。", "1/8 turn between 2-3", "", ""] },
          { items: ["4Q", "右足を女性のアウトサイドに出す。", "1/8 turn between 3-4", "", ""] },
          { items: ["5Q", "左足を後退する。", "Com to turn R", "", ""] },
          { items: ["6Q", "右足を横へ", "1/4 turn between 5-6", "", ""] },
          { items: ["7&", "左足を右足に揃える", "", "", ""] },
          { items: ["8Q", "右足を横に開く", "Com to turn R", "", ""] },
          { items: ["9Q", "左足を前進する。", "", "1/8 turn between 8-9", ""] },
          { items: ["10Q", "PP状態になる。", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "5Q-8Qは、Chase to Rightの動作である。",
              "9Q-10Qは、Progressive Linkの動作である。"
            ]
          },
        ],
        videos: []
      }, // end of id=24
      {
        id: "25",
        title: "ストーキング・ウォーク Stalking Walks(S&SS&S)",
        rows: [
          { items: ["1S", "PPの状態から左足を横に出し、左足に体重を乗せる。", "", "", ""] },
          { items: ["2&", "左足体重のまま右足を寄せ、一瞬、右足に体重を乗せる。", "", "", ""] },
          { items: ["3S", "右足体重のまま左足を出す（ポイント）。", "", "", ""] },
          { items: ["4S", "PPの状態から右足を横に出し、右足に体重を乗せる。", "", "", ""] },
          { items: ["5&", "右足体重のまま左足を右足の横に出し、一瞬、左足に体重を乗せる。", "", "", ""] },
          { items: ["6S", "右足体重のまま左足を出す（ポイント）。", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "Stalking Walksは、PPの状態から開始する。",
              "9Q-10Qは、Progressive Linkの動作である。"
            ]
          },
        ],
        videos: []
      }, // end of id=25
      {
        id: "26",
        title: "シャッセ・ツー・ライト Chasse to Right(QQ&Q)",
        rows: [
          { items: ["1Q", "左足を後退する。", "Com to turn R", "", ""] },
          { items: ["2Q", "右足を横へ", "1/4 turn between 5-6", "", ""] },
          { items: ["3&", "左足を右足に揃える", "", "", ""] },
          { items: ["4Q", "右足を横に開く", "Com to turn R", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "Chaseの5Q-8Qと同じ動作である。",
              "TODO"
            ],
          },
        ],
        videos: []
      }, // end of id=26
      {
        id: "27",
        title: "シャッセ・ツー・レフト Chasse to Left(QQ&Q)",
        rows: [
          { items: ["1Q", "右足を後退する。", "Com to turn R", "", ""] },
          { items: ["2Q", "左足を横へ", "1/4 turn between 5-6", "", ""] },
          { items: ["3&", "右足を左足に揃える", "", "", ""] },
          { items: ["4Q", "左足を横に開く", "Com to turn R", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ],
          },
        ],
        videos: []
      }, // end of id=27
      {
        id: "28",
        title: "ブラシ・タップ Brush Tap(QQ&S)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "1/8 to L before 1", "HF", ""] },
          { items: ["2Q", "RF to side", "", "BH", ""] },
          { items: ["3&", "Close LF to RF without weight", "", "Foot slightly off floor", ""] },
          { items: ["4S", "Place LF to side without weight, knee veering inward", "", "i/e of B", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ],
          }
        ],
        videos: [{title: "Tango Brush Tap", videoId: "Bf7-xEs27YM"}]
      }, // end of id=28
      {
        id: "29",
        title: "プロムナード・リンク Promenade Link(SQQ)",
        rows: [
          { items: ["1Q", "LF to side", "", "HF", "左足を右足にクロスさせる場合もある"] },
          { items: ["2Q", "RF fwd & across in CBMP", "", "HF", ""] },
          { items: ["3Q", "Place LF to side without weight, knee veering inward", "", "i/e of B", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "Chaseの5Q-8Qと同じ動作である。",
              "TODO"
            ],
          },
        ],
        videos: []
      }, // end of id=29
      {
        id: "30",
        title: "右サイド・オーバースウェイ* Oversway(SSS)",
        rows: [
          { items: ["1S", "左体重のまま右足を伸ばす（ポイント）", "", "?", ""] },
          { items: ["2S", "上半身を右1/4回転させながら、右足に体重を乗せる", "", "?", ""] },
          { items: ["3S", "右足を元の左足横の位置を戻し、左体重に戻す", "", "H", "?"] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          },
        ],
        videos: [{ title: "Tango Oversway", videoId: "1SgRywyPC34" }]
      }, // end of id=30
      {
        id: "31",
        title: "ツイスト＆シャッセ・ツー・レフト* Twist & Chasse to Left*(SQQSQ&Q)",
        rows: [
          { items: ["1S", "ポイントしていた左足を横に出す。", "", "?", ""] },
          { items: ["2Q", "右足を前に出し、同時に左足を揃えて左にツストする。", "", "?", ""] },
          { items: ["3Q", "右足と左足を揃えたまま右にツストする。", "", "H", "?"] },
          { items: ["4S", "右足を前に出す。", "Com to turn R", "", ""] },
          { items: ["5Q", "左足を横へ", "1/4 turn between 5-6", "", ""] },
          { items: ["6&", "右足を左足に揃える", "", "", ""] },
          { items: ["7Q", "左足を横に開く", "Com to turn R", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          },
        ],
        videos: [{title: "Tango Oversway", videoId: "1SgRywyPC34"}]
      }, // end of id=31
      {
        id: "32",
        title: "フォーラウェイ・リバース＆スリップ・ピボット Fallaway Reverse & Slip Pivot(QQQQ)",
        rows: [
          { items: ["1Q", "LF fwd", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF back, R side leading", "3/8 between 1-2, body turns less", "BH", ""] },
          { items: ["3Q", "LF back in CBMP", "1/8 between 2-3", "BH", ""] },
          { items: ["4Q", "RF back, LF held in CBMP", "1/8 between 3-4, then 1/4 on 4 (Pivot)", "BHB", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "3Sで体を左に傾けて左体重になる。",
              "4Sで左体重のまま体を右に傾ける。"
            ]
          },
        ],
        videos: [{title: "Tango Oversway", videoId: "1SgRywyPC34"}]
      }, // end of id=32
      {
        id: "33",
        title: "フォー・ステップ Four Step(QQQQ)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2, body turns less", "BH", ""] },
          { items: ["3Q", "LF back in CBMP", "", "BH", ""] },
          { items: ["4Q", "Close RF slightly behind LF", "Body turn to R", "BH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          },
        ],
        videos: [{title: "Tango Oversway", videoId: "1SgRywyPC34"}]
      }, // end of id=33
      {
        id: "34",
        title: "PSS・リバースターン Progressive Side Step Reverse Turn(QQSS QQSS QQS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] }, // 1
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2, body turns less", "i/e of WF", ""] }, // 2
          { items: ["3S", "LF fwd in CBMP", "", "HF", ""] }, // 3
          { items: ["4S", "RF fwd, R side leading", "Body turn to R", "HF", ""] }, // 4
          
          { items: ["5Q", "Transfer weight to LF, L side leading", "", "i/e of BH", ""] }, // 5
          { items: ["6Q", "Transfer weight to RF, R side leading", "", "WF", ""] }, // 6
          { items: ["7S", "LF back, small step, L side leading", "1/8 to L", "i/e of BH", ""] }, // 7
          
          { items: ["8S", "RF back, small step, toe turned in", "1/8 between 7-8", "BH", ""] }, // 8
          { items: ["9Q", "LF fwd in CBMP", "1/8 to L gradually over 9-11", "HF", ""] }, // 9
          { items: ["10Q", "RF to side & slightly back", "", "i/e of WF", ""] }, // 10
          { items: ["11S", "LF fwd in CBMP", "", "HF", ""] }, // 11
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          },
        ],
        videos: [{title: "Tango Oversway", videoId: "1SgRywyPC34"}]
      }, // end of id=34
      {
        id: "35",
        title: "ベーシンク・リバース・ターン Basic Reverse Turn(QQSQQS)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side & slightly back", "1/4 between 1-2", "BH", ""] },
          { items: ["3S", "LF crosses in front of RF", "1/8 between 2-3, body turns less", "WF", ""] },
          { items: ["4Q", "RF back", "Body completes turn", "BH", ""] },
          { items: ["5Q", "LF to side & slightly fwd", "3/8 between 4-5, body turns less", "i/e of WF", ""] },
          { items: ["6S", "RF closes to LF, slightly behind", "Body completes turn", "WF", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "「QQ&QQS」と言うステップも使用される（シンコぺーティッド）。",
              "TODO"
            ]
          },
        ],
        videos: [{title: "Tango Oversway", videoId: "1SgRywyPC34"}]
      }, // end of id=35
      {
        id: "36",
        title: "リバース・アウトサイド・スイブル Reverse Outside Swivel（QQSQQ)",
        rows: [
          { items: ["1Q", "LF fwd in CBMP", "Com to turn L", "HF", ""] },
          { items: ["2Q", "RF to side", "1/4 between 1-2", "BH", ""] },
          { items: ["3S", "LF back in CBMP, then swivel on LF with RF held in front in CBMP", "1/4 between 2-3, then a further 1/8, body turns less", "BH", ""] },
          { items: ["4Q", "RF fwd & across in CBMP", "1/8 to L between 3-4, body turns less", "HF", ""] },
          { items: ["5Q", "Place LF to side without weight", "Body completes turn", "i/e of B", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          },
        ],
        videos: []
      }, // end of id=36
      {
        id: "37",
        title: "バック・オープン・プロムナード Back Open Promenade（SQQS)",
        rows: [
          { items: ["1Q", "LF to side", "", "HF", ""] },
          { items: ["2Q", "RF fwd & across in CBM", "", "HF", ""] },
          { items: ["3Q", "LF to side & slightly back", "1/4 to R between 2-3", "BH", ""] },
          { items: ["4S", "RF back", "Body turn to L", "BH", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          },
        ],
        videos: []
      }, // end of id=37

    ]
  }; // end of contents4

  // ====ルンバ========================
  rumba_amalgamations: Comment3[] = [
    {
      title: "#1 part",
      items: [
        { id: "0", td1: ["予備歩", "Basic in Place(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["オープン・ヒップ・ツイスト", "Open Hip Twist(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["ホッケー・スティック", "Hockey Stick(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["オープン・ヒップ・ツイスト", "Open Hip Twist(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["アレマーナ", "Alemana(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["ボックス", "Box(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["ホッケー・スティック", "Hockey Stick(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ニューヨーク（左側）", "New York to Left Side Position(2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ニューヨーク（右側）", "New York to Right Side Position(2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ニューヨーク（左側）", "New York to Left Side Position(2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["スポット・ターン（左側）", "Spot Turn to Left(2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["クローズド・ベーシック", "Closed Basic(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["ボックス", "Box(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["マンボの足", "????(2341 2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ナチュラル・トップ", "Natural Top(2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["ロープ・スピニング", "Rope Spinning(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["スライディング・ドア", "Sliding Doors(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["スリー・アレマーナ", "Three Alamanas(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "24", td1: ["*サーキュラー・ヒップ・ツイスト", " Circular Hip Twist(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },

        { id: "16", td1: ["ファン", "Fan(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "23", td1: ["チェック", "Check(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },


        { id: "17", td1: ["オープニング・アウト・ツー・ライト・アンド・レフト", "Opening Out to Right and Left(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["オープニング・アウト・ツー・レフト", "Opening Out to Left(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "19", td1: ["スリー・スリーズ", "Three Threes(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "20", td1: ["スパイラル", "Spiral(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "21", td1: ["ルンバ・ウォーク（後退）", "Rumba Walk(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "22", td1: ["シンコペーテデッド・キューバン・ロック", "Syncopated Cuban Rock(2&341 2&341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "17", td1: ["オープニング・アウト・ツー・ライト・アンド・レフト", "Opening Out to Right and Left(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["オープニング・アウト・ツー・レフト", "Opening Out to Left(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "16", td1: ["ファン", "Fan(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "23", td1: ["チェック", "Check(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"] }

        /*
        { id: "", td1: ["マンボの足1の後半?", "??(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["サーキュラー・ヒップ・ツイスト", "Circular Hip Twist(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["チェックして終？", "？？(2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["スリー・アレマーナ", "Three Alemanas(2341 2341 2341 2341)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["スリー・スリーズ", "Three Threes(2341 2341 2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["オープニング・アウト（右→左）", "Opening Out to the Right and Left(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["左側ショルダー・ツー・ショルダー", "Left Side Shoulder to Shoulder(2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["右側ショルダー・ツー・ショルダー", "Right Side Shoulder to Shoulder(2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["ボックス？", "Box?(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["クローズド・ヒップ・ツイスト", "Closed Hip Twist(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["アレマーナ", "Alemana(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["スパイラル", "Spiral(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["アレマーナ", "Alemana(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["オープニング・アウト（右→左）", "Opening Out to the Right and Left(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["オープニング・アウト（右→左）", "Opening Out to the Right and Left(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["スライディング・ドア", "Sliding Doors(2341 2341 2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["サーキュラー・ヒップ・ツイスト", "Circular Hip Twist(2341 2341 2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "", td1: ["スパイラル", "Spiral(2341 2341)"], td2: "0", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        */
      ],
    }, //end of #1 part
  ]
  
  private contents5: Description2 = {
    id: "5",
    title: "ルンバ（Rumba）：初級コース",
    descriptions: [
      {
        id: "0",
        title: "予備歩 Basic in Place(2341 2341)",
        rows: [
          { items: ["2", "Close LF to RF", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Transfer weight to LF", "", "", ""] },
          { items: ["2", "Transfer weight to RF", "", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "Transfer weight to RF", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=0
      {
        id: "1",
        title: "オープン・ヒップ・ツイスト Open Hip Twist(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "Open", ""] },
          { items: ["3", "Transfer weight to RF", "", "Open", ""] },
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "RF to side", "1/8 to L between 5-6", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=1
      {
        id: "2",
        title: "ホッケー・スティック Hockey Stick(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Fwd Cucaracha)", "", "Fan", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "1/8 to R between 3-4", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "RF fwd", "", "Open", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=2
      {
        id: "3",
        title: "アレマーナ Alemana(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Fwd Cucaracha)", "", "Fan", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=3
      {
        id: "4",
        title: "ボックス Box(2341 2341)",
        rows: [
          { items: ["2", "LF to side, part weight", "1/8 to R before 1", "RSP", ""] },
          { items: ["3", "Transfer weight to RF", "", "RSP", ""] },
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "RF to side", "1/8 to L between 5-6", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "前半は、Opening Out to Left(123)に似ている。",
              "後半は、Open Hip Twist(456)"
            ],
          },
        ],
        videos: []
      }, // end of id=4
      {
        id: "5",
        title: "ニューヨーク（左側） New York to Left Side Position(2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "1/8 to R before 1", "LSP", ""] },
          { items: ["3", "ransfer weight to RF", "", "LSP", ""] },
          { items: ["41", "LF to side", "1/4 to L between 2-3", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=5
      {
        id: "6",
        title: "ニューヨーク（右側） New York to Right Side Position(2341)",
        rows: [
          { items: ["2", "RF fwd (Checked Fwd Walk)", "1/8 to L before 1", "RSP", ""] },
          { items: ["3", "ransfer weight to LF", "", "RSP", ""] },
          { items: ["41", "RF to side", "1/4 to R between 2-3", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=6
      {
        id: "7",
        title: "スポット・ターン（左側） Spot Turn to Left(2341)",
        rows: [
          { items: ["2", "LF fwd & across to end back & slightly to side", "1/8 to R before 1, then 3/8 at the end of 1 (Fwd Walk Turning), turning underarm", "LSP", ""] },
          { items: ["3", "Transfer weight to RF", "", "RSP", ""] },
          { items: ["41", "LF to side", "3/8 to R between 2-3", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=7
      {
        id: "8",
        title: "クローズド・ヒップ・ツイスト Closed Hip Twist(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "1/8 to R before 1", "RSP", ""] },
          { items: ["3", "Transfer weight to RF", "", "RSP", ""] },
          { items: ["41", "RF back (Pressed Back Walk)", "", "OP", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "RF to side", "1/8 to L", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=8
      {
        id: "9",
        title: "クローズド・ベーシック Closed Basic(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "Closed", ""] },
          { items: ["3", "Transfer weight to RF", "", "Closed", ""] },
          { items: ["41", "LF to side", "", "Closed", ""] },
          { items: ["2", "RF back", "", "Closed", ""] },
          { items: ["3", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["41", "RF to side", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=9
      {
        id: "10",
        title: "マンボの足 ????(2341 2341 2341 2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "Closed", ""] },
          { items: ["3", "Transfer weight to RF", "", "Closed", ""] },
          { items: ["41", "LF to side", "", "Closed", ""] },
          { items: ["2", "RF back", "", "Closed", ""] },
          { items: ["3", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["41", "RF to side", "", "Closed", ""] },
          { items: ["2", "LF to side", "", "Closed", ""] },
          { items: ["3", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["41", "LF to side", "", "Closed", ""] },
          { items: ["2", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "Closed", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side)", "", "Closed", ""] },
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "Closed", ""] },
          { items: ["3", "Transfer weight to RF", "", "Closed", ""] },
          { items: ["41", "左足を横（やや前）に伸ばす", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["男性は女性の背後から両手を高く挙げて握る。", "TODO"]
          },
        ],
        videos: []
      }, // end of id=10
      {
        id: "11",
        title: "ナチュラル・トップ Natural Top(2341 2341 2341)",
        rows: [
          { items: ["2", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "Closed", ""] },
          { items: ["41", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["2", "LF to side", "", "Closed", ""] },
          { items: ["3", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["41", "LF to side", "", "Closed", ""] },
          { items: ["2", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "Closed", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side)", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=11
      {
        id: "12",
        title: "ロープ・スピニング Rope Spinning(2341 2341)",
        rows: [
          { items: ["2", "LF to side, part weight", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "End in LSP", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side", "", "End in Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=12
      {
        id: "13",
        title: "スライディング・ドア Sliding Doors(2341 2341 2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Fwd Cucaracha)", "", "Fan", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "1/8 to R between 3-4", "", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF fwd & across toward Lady's L side", "", "Shadow", ""] },
          { items: ["2", "LF fwd (Checked Fwd Walk)", "1/8 to R between 6-7", "Shadow", ""] },
          { items: ["3", "Transfer weight to RF", "", "Shadow", ""] },
          { items: ["41", "LF behind RF (Pressed Back Walk)", "", "Tandem", ""] },
          { items: ["2", "RF to side, part weight", "", "L Shadow", ""] },
          { items: ["3", "Transfer weight to LF", "", "Tandem", ""] },
          { items: ["41", "RF fwd & across toward Lady's L side", "", "R Shadow", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "この踊りは、トークA（初級）のものと違うようだ。",
              "TODO"
            ],
          },
        ],
        videos: []
      }, // end of id=13
      {
        id: "14",
        title: "スリー・アレマーナ Three Alamanas(2341 2341 2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Fwd Cucaracha)", "", "Fan", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""]} ,
          { items: ["41", "Close LF to RF", "", "", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side", "", "Shadow", ""] },
          { items: ["2", "LF to side, part weight", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "LF behind RF (Latin Cross)", "", "Op", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=14
      {
        id: "15",
        title: "ナチュラル・トップ Natural Top(2341 2341 2341)",
        rows: [
          { items: ["2", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "", ""] },
          { items: ["41", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["2", "LF to side", "", "Closed", ""] },
          { items: ["3", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["41", "LF to side", "", "Closed", ""] },
          { items: ["2", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "Closed", ""] },
          { items: ["41", "RF fwd & across toward Lady's R side", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=15
      {
        id: "16",
        title: "ファン Fan(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "Closed", ""] },
          { items: ["3", "Transfer weight to RF", "", "Closed", ""] },
          { items: ["41", "RF behind LF (Pressed Back Walk)", "", "Closed", ""] },
          { items: ["2", "RF back", "", "Closed", ""] },
          { items: ["3", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["41", "RF to side", "", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [],
      }, // end of id=16
      {
        id: "17",
        title: "オープニング・アウト・ツー・ライト・アンド・レフト Opening Out to Right and Left(2341 2341)",
        rows: [
          { items: [ "2", "LF to side, part weight", "", "", ""] },
          { items: [ "3", "Transfer weight to RF", "", "", ""] },
          { items: [ "41", "Close LF to RF", "", "Closed", ""] },
          { items: [ "2", "RF to side, part weight", "", "", ""] },
          { items: [ "3", "Transfer weight to LF", "", "", ""] },
          { items: [ "41", "Close RF to LF", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [],
      }, // end of id=17
      {
        id: "18",
        title: "オープニング・アウト・ツー・レフト Opening Out to Left(2341 2341)",
        rows: [
          { items: ["2", "LF to side, part weight", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "Closed", ""] },
          { items: ["2", "RF back", "", "Closed", ""] },
          { items: ["3", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["41", "RF to side", "", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Opening Out to Right and Leftに続くフィガーである。", "TODO"]
          },
        ],
        videos: [],
      }, // end of id=18
      {
        id: "19",
        title: "スリー・スリーズ Three Threes(2341 2341 2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "Closed", ""] },
          { items: ["2", "RF to side, part weight", "", "Closed", ""] },
          { items: ["3", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["41", "Close RF to LF", "", "Fan", ""] },
          { items: ["2", "LF to side, part weight", "", "", ""] },
          { items: ["3", "Transfer weight to RF", "", "", ""] },
          { items: ["41", "Close LF to RF", "", "Closed", ""] },
          { items: ["2", "RF back", "", "Closed", ""] },
          { items: ["3", "LF to side", "", "Closed", ""] },
          { items: ["41", "RF fwd toward Lady's R side", "", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["先生が「足踏み、足踏み」と呼ぶフィガーである。", "TODO"]
          }
        ],
        videos: [{ title: "Gold Rumba: Three Threes", videoId: "35WuKcIDNLY" }]
      }, // end of id=19
      {
        id: "20",
        title: "スパライル Spiral(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Checked Fwd Walk)", "1/8 to R before 1", "RSP", ""] },
          { items: ["3", "Transfer weight to RF", "", "RSP", ""] },
          { items: ["41", "Close LF to RF", "", "Closed", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "Transfer weight to LF", "", "", ""] },
          { items: ["41", "RF to side", "1/8 to L", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "ボックスに似ているフィガーである。",
              "トークAで使用されているかどうかは不明。"
            ]
          }
        ],
        videos: [{ title: "Silver Rumba: Spiral", videoId: "HstJ-p26jxo" }]
      }, // end of id=20
      {
        id: "21",
        title: "ルンバ・ウォーク（後退） Rumba Walk(2341 2341)",
        rows: [
          { items: ["2", "LF back", "", "Shadow", ""] },
          { items: ["3", "Transfer weight to RF", "", "Shadow", ""] },
          { items: ["41", "LF back", "", "Shadow", ""] },
          { items: ["2", "RF back", "", "", ""] },
          { items: ["3", "LF back", "", "Shadow", ""] },
          { items: ["41", "RF back", "", "Shadow", ""] },
          { items: ["2", "LF back", "", "Shadow", ""] },
          { items: ["3", "RF back", "", "Shadow", ""] },
          { items: ["41", "LF to side", "1/4 to L between 8-9", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: [{ title: "PreBronze Rumba: Progressive Walks: Spiral", videoId: "bXWx-SFCV_s" }]
      }, // end of id=21
      {
        id: "22",
        title: "シンコペーテデッド・キューバン・ロック Syncopated Cuban Rock(2&341 2&341)",
        rows: [
          { items: ["2", "LF to side, part weight", "", "Closed", ""] },
          { items: ["&", "Transfer part weight to RF", "", "Closed", ""] },
          { items: ["3", "Transfer part weight to LF", "", "Closed", ""] },
          { items: ["4", "Transfer weight to RF", "", "Closed", ""] },
          { items: ["1", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["2", "RF to side, part weight", "", "Closed", ""] },
          { items: ["&", "Transfer part weight to LF", "", "Closed", ""] },
          { items: ["3", "Transfer part weight to RF", "", "Closed", ""] },
          { items: ["4", "Transfer weight to LF", "", "Closed", ""] },
          { items: ["1", "Transfer weight to RF", "", "Closed", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: [{ title: "PreBronze Rumba: Cuban Rocks", videoId: "7zEMNc4D-Cw" }]
      }, // end of id=22
      {
        id: "23",
        title: "チェック Check(2341 2341)",
        rows: [
          { items: ["2", "LF fwd (Fwd Cucaracha)", "", "Fan", ""] },
          { items: ["3", "Transfer weight to RF", "", "?", ""] },
          { items: ["41", "Close LF to RF", "", "?", ""] },
          { items: ["2", "RF back", "1/8 to R between 3-4", "", ""] },
          { items: ["3", "LF to side, transfer weight to LF", "", "?", ""] },
          { items: ["41", "右手を上げる", "", "?", ""] },
          { items: ["2", "右手を上げた状態を維持する。左肩を前に出す。", "", "?", ""] },
          { items: ["3", "同上", "", "?", ""] },
          { items: ["41", "同上", "", "?", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
              "TODO",
              "TODO"
            ]
          }
        ],
        videos: []
      }, // end of id=23
      {
        id: "24",
        title: "サーキュラー・ヒップ・ツイスト Circular Hip Twist(2341 2341 2341 2341)",
        rows: [
          { items: ["2", "RF back", "1/8 to R before 1", "RSP", ""] },
          { items: ["3", "Transfer weight to LF", "", "RSP", ""] },
          { items: ["41", "RF fwd & across toward Man's R side (Pressed Fwd Walk)", "", "OP", ""] },
          { items: ["2", "LF fwd & across", "1/8 to L", "", ""] },
          { items: ["3", "RF fwd & across toward Man's R side (Pressed Fwd Walk)", "1/8 to L", "OP", ""] },
          { items: ["41", "LF fwd & across", "1/8 to L", "", ""] },
          { items: ["2", "RF fwd & across toward Man's R side (Pressed Fwd Walk)", "1/8 to L", "", ""] },
          { items: ["3", "LF fwd & across", "1/8 to L", "", ""] },
          { items: ["41", "RF fwd & across toward Man's R side (Pressed Fwd Walk)", "1/8 to L", "OP", ""] },
          { items: ["2", "LF fwd", "L", "", ""] },
          { items: ["3", "RF fwd to end back & slightly to side", "", "", ""] },
          { items: ["41", "LF back", "1/8 to L", "Fan", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          }
        ],
        videos: [{ title: "Gold Rumba: Circular Hip Twist", videoId: "bUvpRLxutzM" }]
      } // end of id=24
    ]
  }; // end of contents5
  
  // ====ジャイブ========================
  jive_videos: Video1[] = [
  	{id: "1", title: "ジャイブ① 社交ダンス 初級ステップ （Jive for Beginner）", videoId: "UgLCJRegPHo"},
  	{id: "2", title: "ジャイブ② 社交ダンス 初級ステップ （Jive② for Beginner）", videoId: "Vxj8LfMnp6Q"},
  	{id: "3", title: "ジャイブ③ 社交ダンス 初中級ステップ （Jive③ for Pre-Intermediate）", videoId: "XHvRNFT4mi0"},
  	{id: "4", title: "ジャイブ④ 社交ダンス 初中級ステップ （Jive④ for Pre-Intermediate）", videoId: "6TGHKe1E5p4"},
  	{id: "5", title: "社交ダンス ジャイブ(JIVE) ベーシックステップ ヤングサークルほほえみ", videoId: "kjkV3IpLQBk"},
  	{id: "6", title: "Bryan Watson & Carmen - Jive (WSSDF2007)", videoId: "eWzUtl13x4A"},
  	{id: "7", title: "2007年第28回日本インターナショナルダンス選手権大会（更新）", videoId: "6CG2O2KYqhE"},
  	{id: "8", title: "Whiteys Lindy Hoppers .. Hellzapoppin.", videoId: "ahoJReiCaPk"},
  	{id: "9", title: "動画先生#046 【ジャイブ(エクササイズ)】社交ダンス。。。", videoId: "j1UMZcsry60"},
  	{id: "10", title: "動画先生#047 【ジャイブ(タイミング)】社交ダンス。。。", videoId: "CzHA-xilOk8"},
  	{id: "11", title: "動画先生#048 【ジャイブ(バウンズ)】社交ダンス。。。", videoId: "9XeeIk9zTlE"},
  ]

  jive_amalgamations: Comment3[] = [
    {
      title: "中級コース: #1 part",
      items: [
        { id: "0", td1: ["予備歩", "Basic in Place(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["フォールアウェイ・ロック", "Fallaway Rock(QQ QaQ QaQ)"], td2: "", td3: "C→C", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "1", td1: ["フォールアウェイ・ロック", "Fallaway Rock(QQ QaQ QaQ)"], td2: "", td3: "C→C", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["チェンジ・プレイス・ライト・ツー・レフト(QQ QaQ QaQ)", "Change of Places Right to Left(QQ QaQ QaQ)"], td2: "", td3: "C→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["チェンジ・プレイス・レフト・ツー・ライト(QQ QaQ QaQ)", "Change of Places Left to Right(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["チェンジ・オブ・ハンズ・ビハインド・ザ・バック", "Change of Hands Behind the Back(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["チェンジ・プレイス・レフト・ツー・ライト(QQ QaQ QaQ)", "Change of Places Left to Right(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ヒップ・バンプ", "Hip Bump(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["ヒップ・バンプ", "Hip Bump(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["ストップ・アンド・ゴー", "Stop and Go(QQ QaQ QQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["ストップ・アンド・ゴー", "Stop and Go(QQ QaQ QQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["チェンジ・プレイス・レフト・ツー・ライト", "Change of Places Left to Right(QQ QaQ QaQ)"], td2: "", td3: "O→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "13", td1: ["トゥー・ヒール・スイベル1", "Toe Heel Swivels(QQ QQQ QQQ QQQ QQQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["フォールアウェイ・スローアウェイ", "Fallaway Throwaway(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "15", td1: ["チキン・ウォーク1", "Chicken Walk(SS QQQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "17", td1: ["オーバーターンド・フォールアウェイ・スローアウェイ", "Overturned Fallaway Throwaway(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "16", td1: ["チキン・ウォーク2", "Chicken Walk(QQQQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "17", td1: ["オーバーターンド・フォールアウェイ・スローアウェイ", "Overturned Fallaway Throwaway(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "12", td1: ["ダブル・ホイップ", "Double Whip(QQ QaQ QQQQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "3", td1: ["リンク", "Link(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "11", td1: ["ムーク", "Mooch(QQ QQ QQ QQ QaQ QQ QQ QQ QQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "18", td1: ["カーリー・ホイップ", "Curly Whip（QQ QaQ QQQQ QaQ"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "19", td1: ["プロムナード・ウォーク", "Promenade Walks(QQ SS QQ QQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "4", td1: ["チェンジ・プレイス・ライト・ツー・レフト(QaQ QaQ)", "Change of Places Right to Left(QaQ QaQ)"], td2: "", td3: "C→O", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "0", td1: ["予備歩", "Basic in Place(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["アメリカン・スピン", "American Spin(QQ QaQ QaQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["ザ・ウォーク", "The Walks(QQ QaQ QaQ QQ QQ)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "14", td1: ["トゥ・ヒール・スイベル2", "Toe Heel Swivels(QQQQ SQQSQQ QQQQ)"], td2: "", td3: "両手", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },

      ],
    }, //end of #1 part
  ]
  
  private contents6: Description2 = {
    id: "6",
    title: "ジャイブ（Jive）：中級コース",
    descriptions: [
      {
        id: "0",
        title: "予備歩 Basic in Place(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "Close LF to RF", "", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF to side", "", "", ""] },
          { items: ["1", "RF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF to side", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Basic in Place", videoId: "-UA19p2lJbA" }]
      }, // end of id=0
      {
        id: "1",
        title: "フォールアウェイ・ロック Fallaway Rock(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF to side", "1/8 to R over 2-5", "", ""] },
          { items: ["1", "RF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF to side", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Closed Positionから始め、Closed Positionで終わる", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Fallaway Rock", videoId: "eMrwDuuwRpU" }]
      }, // end of id=1
      {
        id: "2",
        title: "フォールアウェイ・スローアウェイ Fallaway Throwaway(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step(Close Position)", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF diag fwd, part weight", "", "Diag Fwd Chasse", ""] },
          { items: ["a", "RF crosses behind LF", "", "", ""] },
          { items: ["4", "LF diag fwd", "1/8 to R over 2-5", "", ""] },
          { items: ["1", "RF to side, part weight", "1/8 to L between 5-6", "Fwd Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF fwd", "", "Open Position", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Change of Places R to Lと似ているが女性は右に1/8向いた後、左廻りに回転する。", "Closed Positionから始め、Open Positionで終わる。"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Fallaway Throwaway", videoId: "PaNikWP2JUk" }]
      }, // end of id=2
      {
        id: "3",
        title: "リンク Link(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "", "Rock Step(Open Position)", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF fwd, part weight", "", "Fwd Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF fwd", "", "", ""] },
          { items: ["1", "RF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF to side", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Open PositionからClosed Positionに戻る。", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Jive: the Link", videoId: "V1VJufHCq3c" }]
      }, // end of id=3
      {
        id: "4",
        title: "チェンジ・プレイス・ライト・ツー・レフト Change of Places Right to Left(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step(Open Position)", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF diag fwd, part weight", "", "Diag Fwd Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF diag fwd", "", "", ""] },
          { items: ["1", "RF fwd, part weight", "", "Fwd Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF fwd", "1/8 to L over 6-8", "Open Position", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: [
            	"Fallaway Throwawayと似ているが女性は右廻りに回転するの男性は左手を上げる。Closed Positionから始め、Open Positionで終わる。",
            	"最終的に左に90度回転する。"
            ]
          },
        ],
        videos: [{ title: "PreBronze Jive: Change of Places Right to Left", videoId: "5tE8CyHRbpk" }]
      }, // end of id=4
      {
        id: "5",
        title: "チェンジ・プレイス・レフト・ツー・ライト Change of Places Right to Left(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "", "Rock Step(Open Position)", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF fwd, part weight", "", "Fwd Chasse, turned at the end", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF fwd to end back & slightly to side", "3/8 to R", "", ""] },
          { items: ["1", "RF fwd, part weight", "", "Fwd Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF fwd", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["R to Lとは逆に、女性は左廻りに回転するの男性は左手を上げる。Open Positionから始め、Open Positionで終わる。",
             "最終的に右に135度回転する。"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Change of Places Left to Right", videoId: "SDJ49edAC5c" }]
      }, // end of id=5
      {
        id: "6",
        title: "ヒップ・バンプ Hip Bump(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF diag fwd, part weight", "", "Turning Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF to side & slightly back, then bump L hip to Lady's R hip", "3/8 to R over 3-5", "", ""] },
          { items: ["1", "RF to side, part weight", "", "Turning Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF back", "3/8 to L over 6-8", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Open Positionから始め、Open Positionで終わる。", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Hip Bump (or Left Shoulder Shove)", videoId: "b1H-OtxFi9k" }]
      }, // end of id=6
      {
        id: "7",
        title: "チェンジ・オブ・ハンズ・ビハインド・ザ・バック Change of Hands Behind the Back(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF fwd, part weight", "", "Fwd Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF fwd", "1/8 to L over 3-5", "", ""] },
          { items: ["1", "RF diag fwd, part weight", "", "Turning Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF back", "3/8 to L over 6-8", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Open Positionから始め、Open Positionで終わる。", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Jive: Change of Hands behind the Back", videoId: "nyDiFaJpZyg" }]
      }, // end of id=7
      {
        id: "8",
        title: "アメリカン・スピン American Spin",
        rows: [
          { items: ["1", "LF back", "", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF fwd, small step, part weight", "", "Compact Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF fwd, small step", "3/8 to R over 3-5", "", ""] },
          { items: ["1", "RF fwd, small step, part weight", "", "Compact Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["2", "RF fwd, small step", "", "", ""] }
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "Bronze Jive: American Spin", videoId: "rbrFdmJLs1M" }]
      }, // end of id=8
      {
        id: "9",
        title: "ザ・ウォーク The Walks(QQ QaQ QaQ QQQQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "", ""] }, // 2
          { items: ["3", "LF diag fwd, part weight", "", "Diag Fwd Chasse", ""] }, // 3
          { items: ["a", "RF closes halfway to LF", "", "", ""] }, // 4
          { items: ["4", "LF diag fwd", "3/8 to R over 3-5", "", ""] }, // 5
          { items: ["1", "RF fwd, part weight", "1/8 to L between 5-6", "Fwd Chasse, then Swivel", ""] }, // 6
          { items: ["a", "LF closes halfway to RF", "", "", ""] }, // 7
          { items: ["2", "RF fwd, small step", "", "", ""] }, // 8
          { items: ["3", "LF almost closes to RF", "1/8 to R between 8-9", "Step in place, then Swivel", ""] }, // 9
          { items: ["4", "RF fwd", "1/8 to L between 9-10", "Fwd Walk on flexed knee, then Swivel", ""] }, // 10
          { items: ["1", "LF diag fwd", "1/8 to R between 10-11", "Step in place, then Swivel", ""] }, // 11
          { items: ["2", "RF fwd", "1/8 to L between 11-12, then 1/8 to R", "Fwd Walk on flexed knee, then Swivel", ""] } // 12
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "Bronze Jive: Walks", videoId: "hLMSxwHZRIc" }]
      }, // end of id=9
      {
        id: "10",
        title: "ストップ・アンド・ゴー Stop and Go",
        rows: [
          { items: ["1", "LF back", "", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF fwd, part weight", "", "Fwd Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF fwd", "", "", ""] },
          { items: ["1", "RF fwd, knee flexed", "", "Checked Fwd Walk", ""] },
          { items: ["2", "Replace weight to LF", "", "", ""] },
          { items: ["3", "RF back, part weight", "", "Bwd Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["4", "RF back", "", "", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["Open Positionから始め、Open Positionで終わる。", "女性は前半は左回転し後半は右回転するので、男性は左手を上げる。"]
          },
        ],
        videos: [{ title: "Bronze Jive: Stop and Go", videoId: "qqFx8sq88Ak" }]
      }, // end of id=10
      {
        id: "11",
        title: "ムーク Mooch(QQ QQ QQ QQ QaQ QQ QQ QQ QQ QaQ)",
        rows: [
          { items: ["1", "LF back", "1/4 to L", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "", ""] }, // 2
          { items: ["3", "Kick LF fwd & across, just off the floor", "", "Kick", ""] }, // 3
          { items: ["4", "Close LF to RF", "", "Step in place", ""] }, // 4
          { items: ["1", "Kick RF fwd & across, just off the floor", "", "Kick", ""] }, // 5
          { items: ["2", "Close RF to LF", "", "Step in place", ""] }, // 6
          { items: ["3", "LF back", "", "Rock Step", ""] }, // 7
          { items: ["4", "Replace weight to RF", "", "", ""] }, // 8
          { items: ["1", "LF diag fwd, part weight", "", "Turning Chasse", ""] }, // 9
          { items: ["a", "RF closes halfway to LF", "", "", ""] }, // 10
          { items: ["2", "LF to side", "1/4 to R over 9-11", "", ""] }, // 11

          { items: ["3", "RF back", "1/4 to R", "Rock Step", ""] }, // 12
          { items: ["4", "Replace weight to LF", "", "", ""] }, // 13
          { items: ["1", "Kick RF fwd & across, just off the floor", "", "Kick", ""] }, // 14
          { items: ["2", "Close RF to LF", "", "Step in place", ""] }, // 15
          { items: ["3", "Kick LF fwd & across, just off the floor", "", "Kick", ""] }, // 16
          { items: ["4", "Close LF to RF", "", "Step in place", ""] }, // 17
          { items: ["1", "RF back", "", "Rock Step", ""] }, // 18
          { items: ["2", "Replace weight to LF", "", "", ""] }, // 19

          { items: ["3", "RF diag fwd, part weight", "", "Turning Chasse", ""] }, // 20
          { items: ["a", "LF closes halfway to RF", "", "", ""] }, // 21
          { items: ["4", "RF to side", "1/4 to L over 20-22", "", ""] }, // 22
        ],
        comments: [
          {
            title: "注意事項",
            items: ["最初のQQ(12)で左足を下げ左に90度回転し、次のQQ(34)で左足を蹴り、次のQQ(56)で右足を蹴る。",
             "次のQQ(78)で左足を下げ、次のQaQ(9-10-11)で左足を出しシャッセで右に90度回転する。",
             "次のQQ(12-13)で右足を下げ90度回転し、次のQQ(14-15)で右足を蹴り、次のQQ(16-17)で左足を蹴る。",
             "次のQQ(18-19)で右足を下げ、次のQaQ(20-21-22)で右足を出しシャッセで左に90度回転する。"
             ]
          },
        ],
        videos: [{ title: "Bronze Jive: Mooch", videoId: "Xu407C8-WK0" }]
      }, // end of id=11
      {
        id: "12",
        title: "ダブル・ホイップ Double Whip（QQ QaQ QQQQ QaQ）",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step", ""] },
          { items: ["2", "Replace weight to RF", "", "", ""] },
          { items: ["3", "LF diag fwd, part weight", "", "Turning Chasse", ""] },
          { items: ["a", "RF closes halfway to LF", "", "", ""] },
          { items: ["4", "LF to side", "3/8 to R over 2-5", "", ""] },
          { items: ["1", "RF crosses behind LF (Latin Cross)", "1/4 to R", "Latin Cross", ""] },
          { items: ["2", "LF to side", "1/4 to R", "Side Step", ""] },
          { items: ["1", "RF crosses behind LF (Latin Cross)", "1/4 to R", "Latin Cross", ""] },
          { items: ["2", "LF to side", "1/4 to R", "Side Step", ""] },
          { items: ["3", "RF to side, part weight", "", "Side Chasse", ""] },
          { items: ["a", "LF closes halfway to RF", "", "", ""] },
          { items: ["4", "RF to side", "", "", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "Bronze Jive: the Whip", videoId: "_VmbVgwzc4E" }]
      }, // end of id=12
      {
        id: "13",
        title: "トゥー・ヒール・スイベル1 Toe Heel Swivels(QQ QQQ QQQ QQQ QQQ QaQ)",
        rows: [
          { items: ["1", "LF back", "", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "Tap", ""] }, // 2
          { items: ["3", "Swivel on RF and close L Toe to RF without weight", "1/8 to R", "Tap", ""] }, // 3
          { items: ["4", "Swivel on RF and place L Heel to side without weight", "1/4 to L", "Tap", ""] }, // 4
          { items: ["12", "Swivel on RF and step LF fwd & across", "1/4 to R", "Fwd Step", ""] }, // 5
          { items: ["3", "Swivel on LF and close R Toe to LF without weight", "1/4 to L", "Tap", ""] }, // 6
          { items: ["4", "Swivel on LF and place R Heel to side without weight", "1/4 to R", "Tap", ""] }, // 7
          { items: ["12", "Swivel on LF and step RF fwd & across", "1/4 to L", "Fwd Step", ""] }, // 8
          { items: ["3", "Swivel on RF and close L Toe to RF without weight", "1/4 to R", "Tap", ""] }, // 9
          { items: ["4", "Swivel on RF and place L Heel to side without weight", "1/4 to L", "Tap", ""] }, // 10
          { items: ["1", "Swivel on RF and step LF fwd & across", "1/4 to R", "Fwd Step", ""] }, // 11
          { items: ["2", "Swivel on LF and close R Toe to LF without weight", "1/4 to L", "Tap", ""] }, // 12
          { items: ["3", "Swivel on LF and place R Heel to side without weight", "1/4 to R", "Tap", ""] }, // 13
          { items: ["4", "Swivel on LF and step RF fwd & across", "1/4 to L", "Fwd Step", ""] }, // 14
        ],
        comments: [
          {
            title: "注意事項",
            items: ["女性と両手を握って踊る。", "軸足を回転させ、軸足の方向に爪先とヒールを出す。"]
          },
        ],
        videos: [
          { title: "Gold Jive: Toe Heel Swivels", videoId: "z05tbDbYs-I" },
          { title: "社交ダンス ジャイヴ Ａ３ ステップ 初心者レッスン動画 基本足型動画", videoId: "-RJA_R-ig0A" },
          { title: "動画先生#085【ジャイブ(トーヒールスイブル)】社交ダンス。。。", videoId: "x2j5kjdDqgI" },
        ]
      }, // end of id=13
      {
        id: "14",
        title: "トゥ・ヒール・スイベル2 Toe Heel Swivels(QQ QQS QQS QQ QQQQ)",
        rows: [
          { items: ["1", "LF back", "", "BF", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "BF", ""] }, // 2
          { items: ["3", "Swivel on RF and close L Toe to RF without weight", "1/8 to R", "T", ""] }, // 3
          { items: ["4", "Swivel on RF and place L Heel to side without weight", "1/4 to L", "H", ""] }, // 4
          { items: ["12", "Swivel on RF and step LF fwd & across", "1/4 to R", "BF", ""] }, // 5
          { items: ["3", "Swivel on LF and close R Toe to LF without weight", "1/4 to L", "T", ""] }, // 6
          { items: ["4", "Swivel on LF and place R Heel to side without weight", "1/4 to R", "H", ""] }, // 7
          { items: ["12", "Swivel on LF and step RF fwd & across", "1/4 to L", "BF", ""] }, // 8
          { items: ["3", "Swivel on RF and close L Toe to RF without weight", "1/4 to R", "T", ""] }, // 9
          { items: ["4", "Swivel on RF and place L Heel to side without weight", "1/4 to L", "H", ""] }, // 10
          { items: ["1", "Swivel on RF and step LF fwd & across", "1/4 to R", "BF", ""] }, // 11
          { items: ["2", "Swivel on LF and close R Toe to LF without weight", "1/4 to L", "T", ""] }, // 12
          { items: ["3", "Swivel on LF and place R Heel to side without weight", "1/4 to R", "H", ""] }, // 13
          { items: ["4", "Swivel on LF and step RF fwd & across", "1/4 to L", "BF", ""] }, // 14
        ],
        comments: [
          {
            title: "注意事項",
            items: ["女性と両手を握って踊る。", "軸足を回転させ、軸足の方向に爪先とヒールを出す。"]
          },
        ],
        videos: [
          { title: "Gold Jive: Toe Heel Swivels", videoId: "z05tbDbYs-I" },
          { title: "社交ダンス ジャイヴ Ａ３ ステップ 初心者レッスン動画 基本足型動画", videoId: "-RJA_R-ig0A" },
          { title: "動画先生#085【ジャイブ(トーヒールスイブル)】社交ダンス。。。", videoId: "x2j5kjdDqgI" },
        ]
      }, // end of id=14
      {
        id: "15",
        title: "チキン・ウォーク1 Chicken Walk(SS QQQQ)",
        rows: [
          { items: ["12", "LF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 1
          { items: ["34", "RF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 2
          { items: ["1", "LF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 11
          { items: ["2", "RF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 12
          { items: ["3", "LF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 13
          { items: ["4", "RF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 14
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [
          { title: "Gold Jive: Chicken Walks", videoId: "FI0Zb6jnm5A" },
          { title: "チキンウォークを持つジブ中級ダンスルーチン", videoId: "aIQnwpJslHs" },
          { title: "ジャイブベーシックワークショップ2 | フォールアウェイスローアウェイ、チキンウォーク、シュガープッシュ", videoId: "LF_U0gxrinQ" },
        ]
      }, // end of id=15
      {
        id: "16",
        title: "チキン・ウォーク2 Chicken Walk(QQQQ)",
        rows: [
          { items: ["1", "LF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 11
          { items: ["2", "RF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 12
          { items: ["3", "LF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 13
          { items: ["4", "RF back, small step, knee flexed, part weight", "", "Merengue step back", ""] }, // 14
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [
          { title: "Gold Jive: Chicken Walks", videoId: "FI0Zb6jnm5A" },
          { title: "チキンウォークを持つジブ中級ダンスルーチン", videoId: "aIQnwpJslHs" },
          { title: "ジャイブベーシックワークショップ2 | フォールアウェイスローアウェイ、チキンウォーク、シュガープッシュ", videoId: "LF_U0gxrinQ" },
        ]
      }, // end of id=16
      {
        id: "17",
        title: "オーバーターンド・フォールアウェイ・スローアウェイ Overturned Fallaway Throwaway(QQ QaQ QaQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "", ""] }, // 2
          { items: ["3", "LF diag fwd, part weight", "", "Diag Fwd Chasse", ""] }, // 3
          { items: ["a", "RF closes halfway to LF", "", "", ""] }, // 4
          { items: ["4", "LF diag fwd", "", "", ""] }, // 5
          { items: ["1", "RF fwd, part weight", "1/8 to L over 2-5", "Fwd Lock", ""] }, // 6
          { items: ["a", "LF crosses behind RF", "1/8 to L between 5-6", "", ""] }, // 7
          { items: ["2", "RF fwd", "", "", ""] }, // 8
        ],
        comments: [
          {
            title: "注意事項",
            items: ["最終的に135度左に回転する。左手で女性をホールドする。", 
            	"女性は左回転→右回転で男性に正対する。",
            	"その後、Chicken Walkに入る。",
            	]
          },
        ],
        videos: [
          { title: "ジャイブベーシックワークショップ2 | フォールアウェイスローアウェイ、チキンウォーク、シュガープッシュ", videoId: "LF_U0gxrinQ" },
        ]
      }, // end of id=17
      {
        id: "18",
        title: "カーリー・ホイップ Curly Whip（QQ QaQ QQ QaQ）",
        rows: [
          { items: ["1", "LF back", "", "Closed", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "Closed", ""] }, // 2
          { items: ["3", "LF to side, part weight", "", "", ""] }, // 3
          { items: ["a", "RF closes halfway to LF", "", "", ""] }, // 4
          { items: ["4", "LF to side & slightly fwd", "1/4 to R over 3-5", "End in Closed", ""] }, // 5
          { items: ["1", "RF crosses behind LF (Latin Cross)", "1/4 to R", "Closed", ""] }, // 6
          { items: ["2", "LF to side", "1/4 to R", "Closed", ""] }, // 7
          { items: ["3", "RF to side, part weight", "", "Closed", ""] }, // 8
          { items: ["a", "LF to side", "", "Closed", ""] }, // 9
          { items: ["4", "RF to side, part weight", "", "Closed", ""] }, // 10
        ],
        comments: [
          {
            title: "注意事項",
            items: ["最初のQQ(12)で左足を下げ、次のQaQ(345)で左へのシャッセで右に45度回転する。",
             "次のQQ(67)で右足を左足にクロスして合計右に90度回転し、次のQaQ(89-10)で右へのシャッセで元の状態に戻る。"]
          },
        ],
        videos: [{ title: "Gold Jive: Curly Whip", videoId: "rJetpcvPM_U" }]
      }, // end of id=18
      {
        id: "19",
        title: "ザ・ウォーク Promnade Walks(QQ SS QQQQ)",
        rows: [
          { items: ["1", "LF back", "1/4 to L", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "", ""] }, // 2
          { items: ["3", "LF fwd", "", "", ""] }, // 3
          { items: ["4", "RF fwd", "", "", ""] }, // 4
          { items: ["1", "LF fwd", "", "", ""] }, // 5
          { items: ["2", "RF fwd", "", "", ""] }, // 6
          { items: ["3", "LF fwd", "", "", ""] }, // 7
          { items: ["4", "RF fwd", "", "", ""] }, // 8
        ],
        comments: [
          {
            title: "注意事項",
            items: ["次のステップは「Change of Place R to L」の3～8歩になる。", "TODO"]
          },
        ],
        videos: [{ title: "Bronze Jive: Walks", videoId: "hLMSxwHZRIc" }]
      }, // end of id=19
      {
        id: "20",
        title: "カーリー・ホイップ Reverse Whip(QQ SS QQQQ)",
        rows: [
          { items: ["1", "LF back", "1/8 to L", "Rock Step", ""] }, // 1
          { items: ["2", "Replace weight to RF", "", "", ""] }, // 2
          { items: ["3", "LF crosses in front of RF, part weightd", "", "", ""] }, // 3
          { items: ["4", "RF fwd", "", "", ""] }, // 4
          { items: ["1", "LF fwd", "", "", ""] }, // 5
          { items: ["2", "RF fwd", "", "", ""] }, // 6
          { items: ["3", "LF fwd", "", "", ""] }, // 7
          { items: ["4", "RF fwd", "", "", ""] }, // 8
        ],
        comments: [
          {
            title: "注意事項",
            items: ["次のステップは「Change of Place R to L」の3～8歩になる。", "TODO"]
          },
        ],
        videos: [{ title: "Bronze Jive: Walks", videoId: "hLMSxwHZRIc" }]
      }, // end of id=20

    ]
  }; // end of contents6

  quick_amalgamations: Comment3[] = [
    {
      title: "#1 part",
      items: [
        { id: "0", td1: ["予備歩", "Basic in Place(S(SSS) S(SS) 12)"], td2: "", td3: "", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "5", td1: ["ナチュラル・スピン・ターン", "Natural Spin Turn(SQQS SS)"], td2: "", td3: "右足から前進", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "6", td1: ["プログレッシブ・シャッセ", "Progressive Chasse(SQQS)"], td2: "", td3: "右足から後退", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "7", td1: ["クイック・オープン・レバース", "Quick Open Reverse(SQQS)"], td2: "", td3: "左足から前進", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "8", td1: ["フォー・クイック・ラン", "Four Quick Run(SQQQQS)"], td2: "", td3: "右足から後退", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "2", td1: ["ナチュラル・ターン（1-5歩）", "Natural Turn(SQQSS)"], td2: "", td3: "右足から前進", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "9", td1: ["ルンバ・クロス", "Rumba Cross(QQS)"], td2: "", td3: "左足から前進", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
        { id: "10", td1: ["ランニング・ライト・ターン", "Running Right Turn(SSS QQS)"], td2: "", td3: "右足から前進", turn: ["arrow", "fwd"], s_turn: ["arrow", "fwd"]  },
      ],
    }, //end of #1 part Running Right Turn(SQQ SSSS QQS)
  ]
  
  private contents7: Description2 = {
    id: "7",
    title: "クイック（Quick Step）：中級コース",
    descriptions: [
      {
        id: "0",
        title: "予備歩 Basic in Place(S(SSS) S(SS) 12)",
        rows: [
          { items: ["1234.1234", "LF to side, wide step", "Body turns to R", "Closed", ""] },
          { items: ["1234.12", "RF to side, wide step, then brush LF to RF", "Body turns to L", "Closed", ""] },
          { items: ["34", "LF fwd", "", "S", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=0
      {
        id: "1",
        title: "クォータ・ターン・ツー・ライト Quarter Turn to Right(SQQS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/8 between 1-2", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] },
          { items: ["S", "LF side & slightly back", "", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Quarter Turn to the Right", videoId: "O7sI8BwMT3s" }]
      }, // end of id=1
      {
        id: "2",
        title: "ナチュラル・ターン Natural Turn(SQQS SS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/4 between 1-2", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] },
          { items: ["S", "LF back", "Com to turn R", "Closed", ""] },
          { items: ["S", "RF to side, small step (Heel Pull)", "3/8 between 4-5", "Closed", ""] },
          { items: ["S", "LF fwd", "Slight body turn to L", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Natural Turn", videoId: "1uLw25_uUSo" }]
      }, // end of id=2
      {
        id: "3",
        title: "ナチュラル・ターン・ウィズ・ヘジテーション Natural Turn with Hesitation(SQQS SS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/4 between 1-2", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] },
          { items: ["S", "LF back", "Com to turn R", "Closed", ""] },
          { items: ["S", "RF to side, small step (Heel Pull)", "3/8 between 4-5", "Closed", ""] },
          { items: ["S", "LF closes to RF without weight", "", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Natural Turn with Hesitation", videoId: "j1645xWEVRo" }]
      }, // end of id=3
      {
        id: "4",
        title: "ナチュラル・ピヴォット・ターン Natural Pivot Turn(SQQS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/4 between 1-2", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] },
          { items: ["S", "LF back, toe turned in", "1/2 to R (Pivot)", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Natural Pivot Turn", videoId: "Pox77jqwjHM" }]
      }, // end of id=4
      {
        id: "5",
        title: "ナチュラル・スピン・ターン Natural Spin Turn(SQQS SS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/4 between 1-2", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] },
          { items: ["S", "LF back, toe turned in", "1/2 to R (Pivot)", "Closed", ""] },
          { items: ["S", "RF fwd in CBMP", "Cont to turn", "Closed", ""] },
          { items: ["S", "LF to side & slightly back", "3/8 between 5-6", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Natural Spin Turn", videoId: "ukwxnePvR2A" }]
      }, // end of id=5
      {
        id: "6",
        title: "プログレッシブ・シャッセ Progressive Chasse(SQQS)",
        rows: [
          { items: ["S", "RF back", "Com to turn R", "Closed", ""] },
          { items: ["Q", "LF to side", "1/4 between 1-2, body turns less", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "", "Closed", ""] },
          { items: ["S", "LF side & slightly fwd", "", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: [{ title: "PreBronze Quickstep: Progressive Chasse", videoId: "nCKJ5fuaHJY" }]
      }, // end of id=6
      {
        id: "7",
        title: "クイック・オープン・レバース Quick Open Reverse(SQQS)",
        rows: [
          { items: ["S", "RF fwd in CBMP", "", "OP", ""] },
          { items: ["Q", "LF fwd", "Com to turn L", "Closed", ""] },
          { items: ["Q", "RF to side", "1/4 between 1-2", "Closed", ""] },
          { items: ["S", "LF back in CBMP, small step", "1/8 between 2-3, body turns less", "OP", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=7
      {
        id: "8",
        title: "フォー・クイック・ラン Four Quick Run(SQQQQS)",
        rows: [
          { items: ["S", "RF back", "Com to turn L", "Closed", ""] },
          { items: ["Q", "LF to side & slightly fwd", "3/8 between 1-2, body turns less", "Closed", ""] },
          { items: ["Q", "RF fwd in CBMP", "", "OP", ""] },
          { items: ["Q", "LF diag fwd", "", "Closed", ""] },
          { items: ["Q", "RF crosses behind LF", "", "Closed", ""] },
          { items: ["S", "LF diag fwd", "", "OP", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=8
      {
        id: "9",
        title: "ルンバ・クロス Rumba Cross(SQQS)",
        rows: [
          { items: ["S", "RF fwd", "", "Closed", ""] },
          { items: ["Q", "LF fwd, long step", "Com to turn R", "Closed", ""] },
          { items: ["Q", "RF closes to LF", "1/4 between 2-3", "Closed", ""] },
          { items: ["S", "LF to side & slightly back, toe turned in", "1/4 between 3-4, then 1/2 on 4 (Pivot)", "Closed", ""] },
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=9
      {
        id: "10",
        title: "ランニング・ライト・ターン Running Right Turn(SQQ SSSS QQS)",
        rows: [
          { items: ["S", "RF fwd", "Com to turn R", "Closed", ""] }, // 1
          { items: ["Q", "LF to side", "1/4 between 1-2", "Closed", ""] }, // 2
          { items: ["Q", "RF closes to LF", "1/8 between 2-3", "Closed", ""] }, // 3
          { items: ["S", "LF back, toe turned in", "1/2 to R (Pivot)", "Closed", ""] }, // 4
          { items: ["S", "RF fwd in CBMP", "Cont to turn", "Closed", ""] }, // 5
          { items: ["S", "LF to side", "3/8 between 5-6", "Closed", ""] }, // 6
          { items: ["S", "RF back, R side leading", "1/8 between 6-7", "Closed", ""] }, // 7
          { items: ["Q", "LF back in CBMP", "Cont to turn", "OP", ""] }, // 8
          { items: ["Q", "RF to side & slightly fwd", "3/8 between 8-9", "Closed", ""] }, // 9
          { items: ["S", "LF fwd, L side leading", "Body turns to R", "Closed", ""] }, // 10
        ],
        comments: [
          {
            title: "注意事項",
            items: ["TODO", "TODO"]
          },
        ],
        videos: []
      }, // end of id=10

    ],
  }; // end of contents7

}
